import React, {
    Component
} from 'react';
import {renderToString} from 'react-dom/server'
import {connect} from 'react-redux';
import {
    bindActionCreators,
    Dispatch
} from 'redux';
import memoize from 'memoize-one';
import _ from 'lodash';
import {keys} from 'ts-transformer-keys';
import parse from 'html-react-parser';

import {
    Column,
    ColumnEditorOptions,
    ColumnEvent,
    ColumnFilterElementTemplateOptions,
    ColumnFooterOptions,
    ColumnProps
} from 'primereact/column';
import {ContextMenu} from 'primereact/contextmenu';
import {
    DataTable as PrDataTable,
    DataTableColReorderEvent,
    DataTableColumnResizeEndEvent,
    DataTableContextMenuSingleSelectionChangeEvent,
    DataTableExpandedRows,
    DataTableStateEvent,
    DataTableRowClickEvent,
    DataTableRowEvent,
    DataTableRowToggleEvent,
    DataTableSelectionSingleChangeEvent,
    DataTableSortMeta,
    DataTablePassThroughOptions,
    DataTableProps,
    DataTableRowGroupHeaderTemplateOptions,
    DataTableRowGroupFooterTemplateOptions
} from 'primereact/datatable';
import {
    MenuItem,
    MenuItemCommandEvent
} from 'primereact/menuitem';
import {PaginatorTemplateOptions} from 'primereact/paginator';
import {Tooltip} from 'primereact/tooltip';

import {__} from '~/shared/src/utilities/messageCatalog';
import metaModel from '~/shared/src/utilities/metaModel';
import Item, {
    ItemAttributesSettable,
    ItemOnlyAttributesSettable
} from '~/shared/src/ci/Item';
import Property, {
    PropertyAttributesSettable
} from '~/shared/src/ci/Property';
import EnumProperty from '~/shared/src/ci/EnumProperty';
import Reference, {
    ReferenceAttributesSettable,
    ReferenceOnlyAttributesSettable
} from '~/shared/src/ci/Reference';
import ReferenceProperty, {
    ReferencePropertyAttributesSettable
} from '~/shared/src/ci/ReferenceProperty';
import EnumReferenceProperty from '~/shared/src/ci/EnumReferenceProperty';
import User from '~/shared/src/model/User';
import objectUtils from '~/shared/src/utilities/objectUtils';
import {
    buildDataDescriptor,
    DataDescriptor,
    DataStructure,
    aliasSeparator,
    getDataObject,
    getItemLabelForCypher,
    getReferenceLabelForCypher,
    getReferenceSetsForDataObject,
    fieldSeparator,
    ItemDataDescriptor,
    ReferencePropertyDataDescriptor,
    ReferenceDataDescriptor,
    getDataStructure,
    StaticDataDescriptor
} from '~/shared/src/utilities/dataStructure';
import dataUtils from '~/shared/src/utilities/dataUtils';
import {defaultBaseRequestParameters} from '~/shared/src/utilities/modules/common';
import {
    ColumnConfig,
    ColumnDefinition,
    ColumnFilter,
    ColumnSorter,
    ConfigDescriptor,
    FilterMatchMode,
    FilterValueType,
    RowStyling
} from '~/shared/src/validationSchemes/modules/overview';
import {
    CheckItemKeyUniquenessParameters,
    CheckItemKeyUniquenessResult
} from '~/shared/src/utilities/modules/data';
import {
    isColumnEditable,
    LoadDataParameters
} from '~/shared/src/utilities/modules/datatable';
import {
    LoadMetaDataRowData,
    LoadMetaDataRowDataMapping
} from '~/shared/src/utilities/modules/overview';
import {valuePrecision} from '~/shared/src/utilities/modules/finder';
import {
    Condition,
    DataDescriptorValues
} from '~/shared/src/utilities/condition';
import {Format} from '~/shared/src/utilities/format';
import {Message} from '~/shared/src/utilities/message';
import {Style} from '~/shared/src/utilities/style';
import {getDefaultFilterMatchMode} from '~/shared/src/utilities/filterUtils';
import {
    convertValueForType,
    convertValueToString
} from '~/shared/src/utilities/valueConverters';
import {validateValueForType} from '~/shared/src/utilities/valueValidators';
import messageUtilities from '~/shared/src/utilities/messageUtils';
import {DataObject} from '~/shared/src/utilities/action';
import {isPropertyValueType} from '~/shared/src/mm/PropertySet';
import {EditorConfig} from '~/shared/src/utilities/editorConfig';
import {FilterConfig} from '~/shared/src/utilities/filterConfig';

import FilterField, {
    FilterField as FilterFieldClass
} from '~/frontend/src/components/base/shared/field/FilterField';
import LoadingMaskPanel from '~/frontend/src/components/base/LoadingMaskPanel';

import {StoreState} from '~/frontend/src/store';
import {
    ColumnStyleProps,
    getColumnHeader,
    processColumnStyle
} from '~/frontend/src/components/base/DataTable/utilities';
import {
    getIconSpan,
    getValueDisplayName
} from '~/frontend/src/utilities/renderHelpers';
import {getDefaultValueForType} from '~/frontend/src/utilities/valueDefaults';
import {
    getValueEditor,
    getValueSetEditor
} from '~/frontend/src/utilities/valueEditors';
import {
    formatRenderer,
    isInvalidHTML,
    renderValue,
    resolveStyleToClassNames,
    statusColoringRenderer,
    stylingRenderer
} from '~/frontend/src/utilities/valueRenderers';
import {
    Value,
    getItemForDataDescriptorFromRowData,
    getPropertyForDataDescriptorFromRowData,
    getReferenceForDataDescriptorFromRowData,
    getReferencePropertyForDataDescriptorFromRowData,
    getValueForDataDescriptorFromRowData,
    resolveConditionRecursive
} from '~/frontend/src/utilities/dataUtils';
import {PanelElusiveDataState} from '~/frontend/src/reducers/elusiveData';

import openPanel, {OpenPanel} from '~/frontend/src/actions/panelManager/openPanel';
import openPanelForItemType, {OpenPanelForItemType} from '~/frontend/src/actions/panelManager/openPanelForItemType';
import setParam, {SetParamAction} from '~/frontend/src/actions/panel/common/setParam';
import unsetParam, {UnsetParamAction} from '~/frontend/src/actions/panel/common/unsetParam';
import resetSearch, {ResetSearch} from '~/frontend/src/actions/panel/dataTable/resetSearch';
import setPaginationData, {SetPaginationData} from '~/frontend/src/actions/panel/dataTable/setPaginationData';
import updateItem, {UpdateItem} from '~/frontend/src/actions/data/updateItem';
import updateReference, {UpdateReference} from '~/frontend/src/actions/data/updateReference';
import dispatchBatched, {
    DispatchBatched,
    ScopedDispatch
} from '~/frontend/src/actions/dispatchBatched';
import {
    setElusiveData,
    SetElusiveDataAction
} from '~/frontend/src/actions/elusiveData';
import endRequest, {EndRequest} from '~/frontend/src/actions/ajax/endRequest';
import startRequest, {StartRequest} from '~/frontend/src/actions/ajax/startRequest';
import xhr from '~/frontend/src/utilities/xhr';
import {XhrComponentState} from '~/frontend/src/reducers/xhr';


const columnStylePropsKeys = keys<ColumnStyleProps>(),
      columnPropsKeys      = keys<ColumnProps>();


export type ActionColumns = {
    [ field : string ] : {
        width : number;
        column : JSX.Element
    }
};
export type EditType = 'data' | 'rowData';
export type Variables = {
    [ variable : string ] : any;
};


export type PanelElusiveData = PanelElusiveDataState &
    CellEditorData &
    {
        forceFilterToggle? : number;
        newFilters? : ColumnFilter[];
        lastParams? : LoadDataParameters;
        columnsCache? : ColumnsCache;
        changedCellValues? : ChangedCellValues;
    };

type SetParam = <K extends keyof AllProps>( panelKey : string, paramKey : K, paramValue : AllProps[K] ) => SetParamAction;
type UnsetParam = ( panelKey : string, paramKey : keyof AllProps ) => UnsetParamAction;
type SetElusiveData = ( panelKey : string, data : PanelElusiveData ) => SetElusiveDataAction;


type DefaultConfigDescriptor = ConfigDescriptor & {
    bodyClassName? : string;
    headerClassName? : string;
    filterHeaderClassName? : string;
};

export const defaultProps = {
    ...defaultBaseRequestParameters,

    /**
     * The search string to filter data for.
     */
    searchString: '' as string,

    /**
     * The field names of the columns the searchString searches in.
     */
    searchColumns: [] as string[],

    /**
     * The structure of the column data.
     */
    dataStructure: {} as DataStructure,

    /**
     * The column definition of the columns possible to show in the DataTable.
     */
    columnDefinitions: [] as ColumnDefinition[],

    /**
     * The column defaults for the columns to show in the DataTable.
     */
    columnDefaults: {
        bodyClassName        : 'yn-nowrap-top-column yn-nopadding-column',
        headerClassName      : 'yn-header-column',
        filterHeaderClassName: 'yn-filter-column',

        sortable: true,

        width: 'auto'
    } as DefaultConfigDescriptor,

    /**
     * The column configuration of the columns to show in the DataTable.
     */
    columns: [] as ColumnConfig[],

    /**
     * Columns to be shown in front of the normal columns.
     */
    actionColumns: {} as ActionColumns,

    /**
     * The column filters.
     */
    filters: [] as ColumnFilter[],

    /**
     * The column fixed filters.
     */
    fixFilters: [] as ColumnFilter[],

    /**
     * The column sorters.
     */
    sorters: [] as ColumnSorter[],

    /**
     * The displayed result page.
     */
    page: 1 as number,

    /**
     * The count of rows per result page.
     */
    rows: 50 as number,

    /**
     * Search result loaded from the backend.
     */
    search: false as boolean,

    /**
     * Do a search -> load result from the backend.
     */
    doSearch: false as boolean,

    /**
     * Should the columns fit to the screen size initially.
     */
    forceFit: false as boolean,

    /**
     * Should the columns fit to their content.
     */
    autoLayout: false as boolean,

    /**
     * An array of conditional styling objects.
     */
    rowStyling: [] as RowStyling[],

    /**
     * Should default values shown for properties <strong>or</strong> not.
     */
    showPropertyDefaults: true as boolean,

    /**
     * Should the MetaModel information shown as defined (raw) <strong>or</strong> should they be processed by MessageCatalog.
     */
    rawMode: false as boolean,

    /**
     * Should the MetaModel information as defined additionally shown for processed information <strong>or</strong> not.
     * This applies in the form: &lt;processed MetaModel information&gt; (&lt;defined MetaModel information&gt;)
     *
     * Only applicable if <prop>rawMode</prop> is set to false.
     */
    showAdditionalRawNames: false as boolean,

    /**
     * Display no multiline values in cells.
     */
    noMultiLineCells: true as boolean,

    /**
     * Is the overview editable.
     */
    editable: false as boolean,

    filterable : true as boolean,
    reorderable: true as boolean,
    resizable  : true as boolean,
    sortable   : true as boolean,

    /**
     * Is the overview in editMode.
     */
    editMode: false as boolean,

    editType: 'data' as EditType,

    selectable: true as boolean,

    filterDisplay: 'row' as DataTableProps<any>[ 'filterDisplay' ],

    cellEditorErrors: {} as {
        [ cellId : string ] : string[];
    },

    /**
     * The CSS class name(s) to add to the component.
     */
    className: '' as string,

    scrollLeft: 0 as number,
    scrollTop : 0 as number,

    usePaging: true as boolean
};

export type DefaultProps = typeof defaultProps;

export type Props = {

    /**
     * The uniqueId of the panel the component is used in.
     *
     * Mostly used to extract the components state from the global one
     * and to generate unique dom element ids.
     */
    uid : string;

    /**
     * The dataContext to access global.data with.
     */
    dataContext : string;

    /**
     * An array of objects to display.
     */
    value? : LoadMetaDataRowData[];

    /**
     * An object containing the mapping between the column fields and the value fields.
     */
    valueFieldMapping? : LoadMetaDataRowDataMapping;

    /**
     * A collection of rows or a map object row data keys that are expanded.
     */
    selection? : any;

    /**
     * A collection of rows or a map object row data keys that are expanded.
     */
    expandedRows? : any[] | DataTableExpandedRows;

    /**
     * Footer content of the table.
     */
    footer? : any;

    /**
     * Displays a loader to indicate data load is in progress.
     */
    loading? : boolean;

    /**
     * unique data key prop of PrimeReact:DataTable
     */
    dataKey? : string;

    /**
     * row expanding props of PrimeReact:DataTable
     *
     * @param {any} rowData
     */
    rowExpansionTemplate? : ( rowData : any ) => React.ReactNode;

    /**
     * row grouping props of PrimeReact:DataTable
     */
    groupRowsBy? : string;
    rowGroupMode? : 'subheader' | 'rowspan';
    rowGroupHeaderTemplate? : ( rowData : any, options : DataTableRowGroupHeaderTemplateOptions<LoadMetaDataRowData[]> ) => React.ReactNode | string;
    rowGroupFooterTemplate? : ( rowData : any, options : DataTableRowGroupFooterTemplateOptions<LoadMetaDataRowData[]> ) => React.ReactNode | string;
    expandableRowGroups? : boolean;

    /**
     * Number of total records, defaults to length of value when not defined.
     */
    totalRecords? : number;

    getApplyableFilters? : ( props : AllProps ) => ColumnFilter[];

    /**
     * Handler for reload of the DataTables data
     */
    reload : ( props : AllProps ) => boolean;

    /**
     * Handler for row click
     */
    onRowClick? : ( field : string, rowData : LoadMetaDataRowData, event : React.MouseEvent<HTMLElement> ) => boolean;

    /**
     * Handler for resolving additional row classes for rowStyling
     *
     * @param {LoadMetaDataRowData} rowData
     *
     * @return {{ [ className : string ] : boolean }}
     */
    rowClass? : ( rowData : LoadMetaDataRowData ) => {
        [ className : string ] : boolean
    };

    /**
     * Handler for resolving state for rowStyling
     *
     * @param {LoadMetaDataRowData} rowData
     *
     * @return {'inserted' | 'modified' | 'deleted' | undefined}
     */
    rowState? : ( rowData : LoadMetaDataRowData ) => 'inserted' | 'modified' | 'deleted' | undefined;

    /**
     * The transformer for the module (component) state.
     * NOTE: Have to been set (in opposition to be a default) to be included in the state anyway!
     */
    moduleTransformer? : string;

    onSort? : DataTableProps<LoadMetaDataRowData[]>['onSort'];
    onFilterChange? : ( key : string, field : string, matchMode : FilterMatchMode, value : any, valueType : FilterValueType ) => void;
    onFilterEnterKey? : () => void;
    pt? : DataTablePassThroughOptions;
    paginatorTemplate? : PaginatorTemplateOptions;

    onRowDataChange? : ( field : string, value : string, rowData : LoadMetaDataRowData, event : React.SyntheticEvent, changedCellValues : ChangedCellValues ) => void | Promise<void>;
    onRowDataRevert? : ( field : string, rowData : LoadMetaDataRowData, event : React.SyntheticEvent, changedCellValues : ChangedCellValues ) => void | Promise<void>;
};

export type ComponentProps = Partial<DefaultProps> & Props;
export const componentProps = keys<ComponentProps>();

type StateProps = {

    /**
     * The running requests belonging to this component (uid).
     *
     * Will be mapped from global state.
     */
    xhrRequestsForComponent? : XhrComponentState;

    /**
     * The elusive data (not persisted by redux store) for this component.
     *
     * Will be mapped from global state.
     */
    elusiveData? : PanelElusiveData;

    ownElusiveData? : PanelElusiveData;

    /**
     * The current user.
     *
     * Will be mapped from global state.
     */
    user? : User;

    messageCatalogTimestamp? : number;

    debug : boolean;
};

type ActionProps = {
    // panelManager actions
    openPanel : OpenPanel;
    openPanelForItemType : OpenPanelForItemType;

    // panel actions
    setParam : SetParam;
    unsetParam : UnsetParam;

    // dataTable actions
    resetSearch : ResetSearch;
    setPaginationData : SetPaginationData;

    // data actions
    updateItem : UpdateItem;
    updateReference : UpdateReference;
    dispatchBatched : DispatchBatched;

    // elusiveData actions
    setElusiveData : SetElusiveData;

    endRequest : EndRequest;
    startRequest : StartRequest;
};
const Actions = Object.assign( {}, { openPanel, openPanelForItemType, setParam, unsetParam, resetSearch, setPaginationData, updateItem, updateReference, dispatchBatched, setElusiveData, endRequest, startRequest } ) as any;

export type AllProps = DefaultProps & Props & StateProps & ActionProps;

export type RowData = {
    [ field : string ] : React.ReactNode | LoadMetaDataRowData;
    rowData : LoadMetaDataRowData;
};

export type CellValue = Value & {
    cellId : string;
    dataDescriptor : DataDescriptor;

    initialValue? : any;
    editValue? : any;
    editorErrorMessages? : ( string | JSX.Element | JSX.Element[] )[];
};
export type EditCell = {
    cellId : string;
    field : string;
    rowIndex : number;
};
export type CellEditorValues = {
    [ cellId : string ] : any;
};
export type CellEditorInitialValues = {
    [ cellId : string ] : any;
};
type CellEditorError = {
    field : string;
    rowIndex : number;
    messages : ( string | JSX.Element | JSX.Element[] )[];
};
export type CellEditorErrors = {
    [ cellId : string ] : CellEditorError;
};
export type ChangedCellValues = {
    [ rowId : string ] : {
        [ fieldName : string ] : string;
    };
}
export type CellEditorData = {
    editCell? : EditCell;
    cellEditorValues? : CellEditorValues;
    cellEditorInitialValues? : CellEditorInitialValues;
    cellEditorErrors? : CellEditorErrors;
};
export const cellEditorDataKeys = keys<CellEditorData>();

/**
 * Threaded through revertCellContent / deleteCellContent / setCellValue (and
 * the property/reference wrappers) when iterating many rows. Lets the
 * per-row methods route updateItem / updateReference calls through a scoped
 * dispatch (collected & flushed as one batchActions at the end) and share a
 * single mutable cellEditorValues / cellEditorErrors / changedCellValues map
 * so that only one setElusiveData is emitted after the loop. The dispatch is
 * optional so non-batched callers (e.g. onCellEditComplete) can reuse the
 * same shape without forcing a scoped dispatch.
 */
export type BatchContext = {
    dispatch? : ScopedDispatch;
    cellEditorValues : CellEditorValues;
    cellEditorErrors : CellEditorErrors;
    changedCellValues : ChangedCellValues;
};
type ColumnCacheParameters = {
    schema : Schema;
    columnDefinition : ColumnDefinition;
    columnConfiguration? : ColumnConfig;
    rawMode : boolean;
    showAdditionalRawNames : boolean;
    editMode : boolean;
    language? : String;
    messageCatalogTimestamp? : number;
};
type ColumnCache = {
    cacheParameters? : ColumnCacheParameters;
    column? : React.ReactNode;
};
type FilterCacheParameters = ColumnCacheParameters & {
    columnFilter? : ColumnFilter;
    columnFixFilter? : ColumnFilter;
};
type FilterCache = {
    cacheParameters? : FilterCacheParameters;
    filter? : React.ReactNode;
};
type CellCacheParameters = {
    schema : Schema;
    columnDefinition : ColumnDefinition;
    columnConfiguration? : ColumnConfig;
    timezone : string;
    rawMode : boolean;
    showAdditionalRawNames : boolean;
    showPropertyDefaults : boolean;
    editMode : boolean;
    language? : String;
    messageCatalogTimestamp? : number;

    filterValue : string;
    additionalDependingOnValues? : string;

    value : CellValue[ 'value' ];
    initialValue : CellValue[ 'initialValue' ];
    editValue : CellValue[ 'editValue' ];
    editorErrorMessages : CellValue[ 'editorErrorMessages' ];
    statusId : CellValue[ 'statusId' ];
    isEditable : CellValue[ 'isEditable' ];
    isDefault : CellValue[ 'isDefault' ];
    isNew : CellValue[ 'isNew' ];
    isModified : CellValue[ 'isModified' ];
    isDeleted : CellValue[ 'isDeleted' ];
};
type CellCache = {
    [ cellId : string ] : {
        cacheParameters : CellCacheParameters;
        body : React.ReactNode;
    }
};
type ColumnsCache = {
    [ field : string ] : {
        columnCache : ColumnCache;
        filterCache : FilterCache;
        cellCache : CellCache;
    };
};
type CellProps = {
    filterString? : string;
    format? : Format;
    styling? : Style[];
    tooltip? : Message;
    editable? : boolean;
};


type ColumnEditorProps = ColumnProps & {
    field : string;
    dataDescriptor : DataDescriptor;
    valueType : FilterValueType;

    permissions : GroupPermissions;
    defaultValue? : any;
    helpText? : string,
    validatorRegExp? : string,
    validationErrorText? : string
    editorConfig? : EditorConfig;
};


type State = {
    cacheToggle : boolean;
    contextMenuSelection? : any;
    contextMenuCellInfo? : {
        columnKey : string;
        columnField : string;
        rowData : LoadMetaDataRowData;
    }
};


const deletedStatusId = {
    CFG : metaModel?.[ 'CFG' ]?.getStatus( 'deleted' )?.id,
    DATA: metaModel?.[ 'DATA' ]?.getStatus( 'deleted' )?.id
};

export const resetStatusIdCaches = () => {
    deletedStatusId.CFG = metaModel[ 'CFG' ].getStatus( 'deleted' )?.id;
    deletedStatusId.DATA = metaModel[ 'DATA' ].getStatus( 'deleted' )?.id;
};


/**
 * DataTable
 */
export class DataTable extends Component<AllProps, State> {

    static defaultProps = defaultProps;

    /**
     * Computes an unique identifier for a cell.
     *
     * @param {number} rowIndex
     * @param {string} columnField
     * @param {LoadMetaDataRowData} [rowData]
     * @param {DataDescriptor} [dataDescriptor]
     * @param {AllProps} [props]
     *
     * @return {string}
     */
    static getCellId( rowIndex : number, columnField : string, rowData : LoadMetaDataRowData | undefined = undefined, dataDescriptor : DataDescriptor | undefined = undefined, props : AllProps | undefined = undefined ) : string {
        let retVal : string = `row_${rowIndex}_${columnField.replace( /[.: ()]/g, '_' )}`;

        if ( rowData && dataDescriptor && props ) {
            const {
                      schema,
                      dataContext
                  } = props;

            if ( !dataDescriptor.aggregate && dataDescriptor.type !== 'static' && dataDescriptor.type !== 'expression' ) {
                if ( dataDescriptor.type === 'item' || dataDescriptor.type === 'items' || dataDescriptor.type === 'property' || dataDescriptor.type === 'properties' ) {
                    const itemIdDataDescriptor = buildDataDescriptor( { attributePath: 'item.id' }, dataDescriptor.dataObject ) as ItemDataDescriptor,
                          itemId               = rowData[ itemIdDataDescriptor?.alias ];

                    if ( itemId ) {
                        if ( dataDescriptor.type === 'item' || dataDescriptor.type === 'items' ) {
                            retVal = `item_${itemId}_${dataDescriptor.attribute}`;
                        }
                        else {
                            const propertyIdDataDescriptor = buildDataDescriptor( { attributePath: `property.${dataDescriptor.propertyTypeName}.id` }, dataDescriptor.dataObject ) as ItemDataDescriptor,
                                  propertyId               = rowData[ propertyIdDataDescriptor?.alias ];

                            if ( propertyId ) {
                                retVal = `item_${itemId}_${propertyId}_${dataDescriptor.attribute}`;
                            }
                            else {
                                const item = itemId ? global.data[ dataContext ]?.items?.[ itemId ] : undefined;

                                if ( item ) {
                                    const propertySet = metaModel[ schema ].getPropertySetForItemTypeAndPropertyType( item.itemTypeId, dataDescriptor.propertyTypeName );

                                    if ( propertySet ) {
                                        retVal = `item_${itemId}_pset_${propertySet.id}_${dataDescriptor.attribute}`;
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    const referenceIdDataDescriptor = buildDataDescriptor( { attributePath: 'reference.id' }, dataDescriptor.dataObject ) as ReferenceDataDescriptor,
                          referenceId               = rowData[ referenceIdDataDescriptor?.alias ];

                    if ( referenceId ) {
                        if ( dataDescriptor.type === 'reference' || dataDescriptor.type === 'references' ) {
                            retVal = `ref_${referenceId}_${dataDescriptor.attribute}`;
                        }
                        else {
                            const referencePropertyIdDataDescriptor = buildDataDescriptor( { attributePath: `property.${dataDescriptor.propertyTypeName}.id` }, dataDescriptor.dataObject ) as ReferencePropertyDataDescriptor,
                                  propertyId                        = rowData[ referencePropertyIdDataDescriptor?.alias ];

                            if ( propertyId ) {
                                retVal = `ref_${referenceId}_${propertyId}_${dataDescriptor.attribute}`;
                            }
                            else {
                                const reference = referenceId ? global.data[ dataContext ]?.references?.[ referenceId ] : undefined;

                                if ( reference ) {
                                    const referencePropertySet = metaModel[ schema ].getReferencePropertySetForReferenceSetAndPropertyType( reference.referenceSetId, dataDescriptor.propertyTypeName );

                                    if ( referencePropertySet ) {
                                        retVal = `ref_${referenceId}_rpset_${referencePropertySet.id}_${dataDescriptor.attribute}`;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return retVal;
    }

    /**
     * Computers an unique identifier for a row
     *
     * @param {LoadMetaDataRowData} rowData
     *
     * @return {string}
     */
    static getRowId( rowData : LoadMetaDataRowData ) : string {
        let retVal : string = '';

        if ( rowData[ 'uniqueId' ] ) {
            retVal = rowData[ 'uniqueId' ];
        }
        else {
            const preparedRowData = { ...rowData };

            delete preparedRowData.total_count;

            retVal = JSON.stringify( preparedRowData );
        }

        return retVal;
    }

    // TODO: hole column editing ( mass data change )
    //  -> via context menu (use value for column)
    //  => freeze sorters, filters and searchField (if) until saved
    //  ! because there could be more affected items than loaded (and shown)


    /* properties *************************************************************************************************************************/

    debug : boolean = false;
    renderStartTime = 0 as number;

    notSelectable : boolean = false;
    justSelected : boolean = false;
    columnResizeHandled : boolean = false;
    columnResizeDrag : boolean = false;
    columnResizeReset : boolean = false;
    columnOrderReset : boolean = false;
    contextMenuRef : ContextMenu | null = null;
    dataTable : PrDataTable<LoadMetaDataRowData[]> | null = null;
    renderedColumns : React.ReactNode[] | undefined;
    renderedFilters : {
        [ field : string ] : React.ReactNode
    } | undefined;
    renderedFilterRefs : {
        [ field : string ] : FilterFieldClass
    } = {};
    dataTableValue : RowData[] = [];

    // Cache of the latest editor value per cellId. Set by onEditorChange, consumed
    // (and cleared) by onCellEditComplete/Cancel. Bridges the React-batch window
    // between the debounced setElusiveData flush on blur and the commit handler,
    // which would otherwise read a stale this.props.elusiveData.cellEditorValues.
    pendingEditorValues : { [ cellId : string ] : any } = {};

    doSetScrollPosition : boolean = false;
    debouncedGetScrollPosition : () => void;

    clickTimeout : number = 0;

    uniqueCount : number = 0;


    /**
     * @param props
     */
    constructor( props : AllProps ) {
        // TODO: performance tuning - logging
        const startTime = performance.now();

        super( props );

        // TODO: performance tuning - logging
        this.renderStartTime = startTime;

        this.state = {
            cacheToggle: false
        };

        // memoize some methods for performance
        this.getContextMenuModel = memoize( this.getContextMenuModel );
        this.getMultiSortMeta = memoize( this.getMultiSortMeta );

        // bind event handlers
        this.onPage = this.onPage.bind( this );
        this.onContextMenuSelectionChange = this.onContextMenuSelectionChange.bind( this );
        this.onContextMenu = this.onContextMenu.bind( this );
        this.onContextMenuHide = this.onContextMenuHide.bind( this );
        this.onClick = this.onClick.bind( this );
        this.onSelectionChange = this.onSelectionChange.bind( this );
        this.onRowToggle = this.onRowToggle.bind( this );
        this.onSort = this.onSort.bind( this );
        this.onColumnResizeEnd = this.onColumnResizeEnd.bind( this );
        this.onColumnResizeDragStart = this.onColumnResizeDragStart.bind( this );
        this.onColumnResizeDragEnd = this.onColumnResizeDragEnd.bind( this );
        this.onColReorder = this.onColReorder.bind( this );
        this.onRowClick = this.onRowClick.bind( this );
        this.onFilterChange = this.onFilterChange.bind( this );
        this.onFilterEnterKey = this.onFilterEnterKey.bind( this );
        this.onResolveRowClass = this.onResolveRowClass.bind( this );
        this.getFilter = this.getFilter.bind( this );
        this.getColumnFooter = this.getColumnFooter.bind( this );

        this.debouncedGetScrollPosition = _.debounce( this.getScrollPosition.bind( this ), 250 );

        this.debug = props.debug;

        if ( this.debug ) {
            this.renderStartTime = performance.now();
        }
    }

    /**
     * REACT lifecycle method
     */
    componentDidMount() {
        this.init();
    }

    /**
     * REACT lifecycle method
     */
    componentWillUnmount() {
        this.cleanup();
    }

    /**
     * REACT lifecycle method
     */
    componentDidUpdate( prevProps : AllProps ) {
        this.afterRender();
    }

    /**
     * REACT lifecycle method
     */
    shouldComponentUpdate( nextProps : Readonly<AllProps>, nextState : Readonly<State> ) {
        // TODO: performance tuning - logging
        this.renderStartTime = performance.now();

        const startTime    = this.debug ? performance.now() : 0,
              changedProps = objectUtils.getDiffKeys(
                  this.props,
                  nextProps,
                  [
                      'actionColumns',
                      'cellEditorErrors',
                      'columns',
                      'columnDefaults',
                      'columnDefinitions',
                      'dataStructure',
                      'elusiveData',
                      'elusiveData.changedCellValues',
                      'elusiveData.cellEditorErrors',
                      'elusiveData.cellEditorInitialValues',
                      'elusiveData.cellEditorValues',
                      'elusiveData.columnsCache',
                      'elusiveData.data',
                      'elusiveData.editCell',
                      'ownElusiveData.lastParams',
                      'elusiveData.metaData',
                      'filters',
                      'fixFilters',
                      'footer',
                      'rowClass',
                      'onFilterChange',
                      'onFilterEnterKey',
                      'onSort',
                      'rowExpansionTemplate',
                      'rowGroupHeaderTemplate',
                      'rowGroupFooterTemplate',
                      'rowState',
                      'rowStyling',
                      'sorters',
                      'user',
                      'xhrRequestsForComponent'
                  ],
                  [
                      'elusiveData',
                      'ownElusiveData'
                  ],
                  [
                      'debug',
                      'scrollLeft',
                      'scrollTop',
                      'elusiveData',
                      'elusiveData.columnsCache',
                      'ownElusiveData',
                      'ownElusiveData.columnsCache',
                      'ownElusiveData.newFilters'
                  ]
              ),
              stateChanged = this.state !== nextState;

        let retVal : boolean = stateChanged || Boolean( changedProps.length );

        this.debug = nextProps.debug;

        if ( this.debug ) {
            console.log( 'DataTable - shouldComponentUpdate'.asLogLine( 100 ) );
            console.log( '    changedProps', changedProps );
            console.log( '    stateChanged', stateChanged );
        }

        if ( stateChanged || changedProps.length ) {
            const {
                      columnDefaults,
                      columnDefinitions,
                      columns,
                      dataContext,
                      dataKey,
                      dataStructure,
                      editMode,
                      elusiveData,
                      filterable,
                      filters,
                      fixFilters,
                      groupRowsBy,
                      messageCatalogTimestamp,
                      ownElusiveData,
                      rawMode,
                      schema,
                      searchColumns,
                      showAdditionalRawNames,
                      showPropertyDefaults,
                      sortable,
                      timezone,
                      uid,
                      user,
                      value
                  }            = nextProps,
                  language     = user ? user.language : undefined,
                  forceCaching = this.state.cacheToggle !== nextState.cacheToggle;

            let columnsCache = elusiveData?.columnsCache;

            if ( columns !== undefined ) {

                // render columns
                if (
                    !this.renderedColumns
                    || forceCaching
                    || changedProps.includes( 'schema' )
                    || changedProps.includes( 'columnDefinitions' )
                    || changedProps.includes( 'columns' )
                    || changedProps.includes( 'rawMode' )
                    || changedProps.includes( 'showAdditionalRawNames' )
                    || changedProps.includes( 'editMode' )
                    || changedProps.includes( 'user' )
                    || changedProps.includes( 'messageCatalogTimestamp' )
                ) {
                    const columnFields : string[] = [];

                    if ( this.debug ) {
                        console.log( '   -> render columns' );
                    }

                    let cacheParameters : ColumnCacheParameters,
                        cacheParameterDiff : string[] = [];

                    for ( const columnConfiguration of columns ) {
                        const columnField      = columnConfiguration.field,
                              columnDefinition = columnDefinitions.find( colDef => colDef.field === columnField ) as ColumnDefinition;

                        columnFields.push( columnField );

                        if ( columnDefinition ) {
                            cacheParameters = {
                                schema,
                                columnDefinition,
                                columnConfiguration,
                                rawMode,
                                showAdditionalRawNames,
                                editMode,
                                language,
                                messageCatalogTimestamp
                            };
                            cacheParameterDiff = objectUtils.getDiffKeys( columnsCache?.[ columnField ]?.columnCache.cacheParameters ?? {}, cacheParameters, [ 'columnDefinition', 'columnConfiguration' ] );

                            if ( forceCaching || cacheParameterDiff.length ) {
                                if ( this.debug ) {
                                    console.log( '       -> render column', columnField );
                                }

                                columnsCache = {
                                    ...columnsCache,
                                    [ columnField ]: {
                                        columnCache: {
                                            cacheParameters,
                                            column: this.buildColumn(
                                                schema,
                                                columnDefaults,
                                                columnDefinition,
                                                columnConfiguration,
                                                dataStructure,
                                                rawMode,
                                                showAdditionalRawNames,
                                                editMode,
                                                filterable,
                                                sortable
                                            )
                                        },
                                        filterCache: columnsCache?.[ columnField ]?.filterCache ?? {},
                                        cellCache  : columnsCache?.[ columnField ]?.cellCache ?? {}
                                    }
                                };
                            }
                        }
                        else {

                            // TODO: remove columns not defined

                        }
                    }

                    // cleanup
                    if ( columnsCache ) {
                        for ( const columnField of Object.keys( columnsCache ) as string[] ) {
                            if ( !columnFields.includes( columnField ) ) {
                                delete columnsCache[ columnField ];
                            }
                        }
                    }

                    if ( changedProps.includes( 'columns' ) || columnsCache !== elusiveData?.columnsCache ) {
                        this.renderedColumns = undefined;
                        this.columnResizeReset = true;
                    }

                    if ( changedProps.includes( 'columns' ) ) {
                        // PrimeReact keeps the order of a drag&drop reorder in its own state and applies
                        // it on top of the rendered columns - so a column order coming in from the outside
                        // (e.g. when a view is applied) would be overruled by the last manual reorder
                        this.columnOrderReset = true;
                    }
                }

                // column filters
                if (
                    columnsCache
                    && (
                        !this.renderedFilters
                        || forceCaching
                        || changedProps.includes( 'filters' )
                        || changedProps.includes( 'fixFilters' )
                        || changedProps.includes( 'onFilterChange' )
                        || changedProps.includes( 'onFilterEnterKey' )
                        || changedProps.includes( 'elusiveData.forceFilterToggle' )
                        || columnsCache !== elusiveData?.columnsCache
                    )
                ) {
                    if ( this.debug ) {
                        console.log( '   -> render filters' );
                    }

                    const activeFilters      = elusiveData?.newFilters ?? filters,
                          // these inputs to buildFilter aren't part of cacheParameters
                          // (callback refs / the forceFilterToggle baked into the React key)
                          // so a change has to force a rebuild regardless of the per-column diff
                          forceFilterRebuild = forceCaching
                              || changedProps.includes( 'onFilterChange' )
                              || changedProps.includes( 'onFilterEnterKey' )
                              || changedProps.includes( 'elusiveData.forceFilterToggle' );

                    let nextColumnsCache : ColumnsCache | undefined;

                    for ( const column of Object.values( columnsCache ) ) {
                        const columnConfiguration = column.columnCache.cacheParameters?.columnConfiguration,
                              columnDefinition    = column.columnCache.cacheParameters?.columnDefinition,
                              columnKey           = columnConfiguration?.key,
                              columnField         = columnConfiguration?.field,
                              columnFilter        = activeFilters.find( colFilter => colFilter.field === columnField ),
                              columnFixFilter     = fixFilters.find( colFixFilter => colFixFilter.field === columnField );

                        if ( columnConfiguration && columnDefinition && columnKey && columnField ) {
                            const cacheParameters : FilterCacheParameters = {
                                ...column.columnCache.cacheParameters!,
                                columnFilter,
                                columnFixFilter
                            };

                            const previousCacheParameters = columnsCache[ columnField ]?.filterCache.cacheParameters,
                                  cacheParameterDiff      = previousCacheParameters
                                      ? objectUtils.getDiffKeys(
                                          previousCacheParameters,
                                          cacheParameters,
                                          [ 'columnDefinition', 'columnConfiguration', 'columnFilter', 'columnFixFilter' ]
                                      )
                                      : [ '*' ];

                            if ( forceFilterRebuild || cacheParameterDiff.length ) {
                                if ( this.debug ) {
                                    console.log( '       -> render filter', columnField );
                                }

                                if ( !nextColumnsCache ) {
                                    nextColumnsCache = { ...columnsCache };
                                }

                                nextColumnsCache[ columnField ] = {
                                    columnCache: columnsCache[ columnField ]?.columnCache ?? {},
                                    filterCache: {
                                        cacheParameters,
                                        filter: !columnDefinition.filter || columnDefinition.filterConfig === false
                                            ? undefined
                                            : this.buildFilter(
                                                nextProps,
                                                columnKey,
                                                columnField,
                                                columnDefinition.dataDescriptor,
                                                columnFilter,
                                                columnFixFilter,
                                                columnDefinition.filterConfig
                                            )
                                    },
                                    cellCache  : columnsCache[ columnField ]?.cellCache ?? {}
                                };
                            }
                        }
                    }

                    if ( nextColumnsCache ) {
                        columnsCache = nextColumnsCache;
                        this.renderedFilters = undefined;
                        this.renderedFilterRefs = {};
                    }
                }

                // cell cache
                if ( !value?.length ) {
                    this.dataTableValue = [];
                }
                else if (
                    !this.dataTableValue.length
                    || changedProps.includes( 'schema' )
                    || changedProps.includes( 'columnDefinitions' )
                    || changedProps.includes( 'columns' )
                    || changedProps.includes( 'dataKey' )
                    || changedProps.includes( 'groupRowsBy' )
                    || changedProps.includes( 'rawMode' )
                    || changedProps.includes( 'showAdditionalRawNames' )
                    || changedProps.includes( 'showPropertyDefaults' )
                    || changedProps.includes( 'editMode' )
                    || changedProps.includes( 'user' )
                    || changedProps.includes( 'value' )
                    || changedProps.includes( 'elusiveData.data' )
                    || changedProps.includes( 'elusiveData.changedCellValues' )
                    || changedProps.includes( 'elusiveData.cellEditorValues' )
                    || changedProps.includes( 'elusiveData.cellEditorErrors' )
                    || changedProps.includes( 'elusiveData.variables' )
                    || changedProps.includes( 'elusiveData.treeVariables' )
                ) {
                    // Pure cell-editor update (typing in an open editor): only the touched
                    // cellIds need rebuilding. We use the prev/next diff of the editor maps
                    // to scope the per-cell work; without this the full M*N iteration is the
                    // dominant cost when editing in tables with many rows.
                    let onlyChangedCellIds : Set<string> | undefined;

                    if (
                        this.dataTableValue.length
                        && !changedProps.includes( 'schema' )
                        && !changedProps.includes( 'columnDefinitions' )
                        && !changedProps.includes( 'columns' )
                        && !changedProps.includes( 'dataKey' )
                        && !changedProps.includes( 'groupRowsBy' )
                        && !changedProps.includes( 'rawMode' )
                        && !changedProps.includes( 'showAdditionalRawNames' )
                        && !changedProps.includes( 'showPropertyDefaults' )
                        && !changedProps.includes( 'editMode' )
                        && !changedProps.includes( 'user' )
                        && !changedProps.includes( 'value' )
                        && !changedProps.includes( 'elusiveData.data' )
                        && !changedProps.includes( 'elusiveData.changedCellValues' )
                        && !changedProps.includes( 'elusiveData.variables' )
                        && !changedProps.includes( 'elusiveData.treeVariables' )
                    ) {
                        const prevEditorValues : CellEditorValues = this.props.elusiveData?.cellEditorValues ?? {},
                              nextEditorValues : CellEditorValues = nextProps.elusiveData?.cellEditorValues ?? {},
                              prevEditorErrors : CellEditorErrors = this.props.elusiveData?.cellEditorErrors ?? {},
                              nextEditorErrors : CellEditorErrors = nextProps.elusiveData?.cellEditorErrors ?? {},
                              changedCellIdsSet : Set<string>     = new Set<string>();

                        for ( const cellId of Object.keys( prevEditorValues ) ) {
                            if ( prevEditorValues[ cellId ] !== nextEditorValues[ cellId ] ) {
                                changedCellIdsSet.add( cellId as string );
                            }
                        }
                        for ( const cellId of Object.keys( nextEditorValues ) ) {
                            if ( prevEditorValues[ cellId ] !== nextEditorValues[ cellId ] ) {
                                changedCellIdsSet.add( cellId as string );
                            }
                        }
                        for ( const cellId of Object.keys( prevEditorErrors ) ) {
                            if ( prevEditorErrors[ cellId ] !== nextEditorErrors[ cellId ] ) {
                                changedCellIdsSet.add( cellId as string );
                            }
                        }
                        for ( const cellId of Object.keys( nextEditorErrors ) ) {
                            if ( prevEditorErrors[ cellId ] !== nextEditorErrors[ cellId ] ) {
                                changedCellIdsSet.add( cellId as string );
                            }
                        }

                        onlyChangedCellIds = changedCellIdsSet;
                    }

                    let lastSearchString : string | undefined,
                        lastFilters : ColumnFilter[] | undefined,
                        cacheParameters : CellCacheParameters,
                        cacheParameterDiff : string[] = [];

                    if ( this.debug ) {
                        console.log( '   -> render cells' );
                    }

                    if ( ownElusiveData?.lastParams ) {
                        lastSearchString = ownElusiveData.lastParams.searchString;
                        lastFilters = ownElusiveData.lastParams.filters as ColumnFilter[];
                    }

                    for ( const columnConfiguration of columns ) {
                        const columnField            = columnConfiguration.field,
                              columnDefinition       = columnDefinitions.find( colDef => colDef.field === columnField ) as ColumnDefinition,
                              columnLastFilter       = lastFilters?.find( lastFilter => lastFilter.field === columnField ),
                              columnLastSearchString = searchColumns.includes( columnField ) ? lastSearchString : undefined;

                        if ( columnDefinition ) {
                            const columnFilterOperator = columnLastFilter?.operator;

                            let columnFilterValue = columnLastFilter?.value ?? '';

                            if ( columnFilterValue ) {
                                if ( columnFilterOperator === 'startsWith' || columnFilterOperator === 'notStartsWith' ) {
                                    columnFilterValue = `${columnFilterValue}*`;
                                }
                                else if ( columnFilterOperator === 'endsWith' || columnFilterOperator === 'notEndsWith' ) {
                                    columnFilterValue = `*${columnFilterValue}`;
                                }
                                else if ( columnFilterOperator === 'contains' || columnFilterOperator === 'notContains' ) {
                                    columnFilterValue = `*${columnFilterValue}*`;
                                }
                            }

                            if ( columnLastSearchString ) {
                                if ( columnFilterValue ) {
                                    columnFilterValue += ' || ';
                                }
                                columnFilterValue += columnLastSearchString;
                            }

                            const columnProps                                             = {
                                      filterString: columnFilterValue,
                                      format      : columnConfiguration.format ?? columnDefinition.format,
                                      styling     : columnConfiguration.styling ?? columnDefinition.styling,
                                      tooltip     : columnDefinition.tooltip,
                                      editable    : columnDefinition.editor && isColumnEditable( columnDefinition.dataDescriptor, dataStructure, schema, columnDefinition.permissions )
                                  } as CellProps,
                                  additionalDependingOnDataDescriptors : DataDescriptor[] = [];

                            // get dataDescriptors used in style conditions
                            if ( columnProps.styling?.length ) {
                                const extractStylingFieldNamesRecursive = ( condition : Condition ) => {
                                    if ( condition.leftExpressionDataDescriptor && !additionalDependingOnDataDescriptors.find( aDODD => aDODD.alias === condition.leftExpressionDataDescriptor!.alias ) ) {
                                        additionalDependingOnDataDescriptors.push( condition.leftExpressionDataDescriptor );
                                    }
                                    if ( Array.isArray( condition.leftExpression ) ) {
                                        for ( const subCondition of condition.leftExpression ) {
                                            extractStylingFieldNamesRecursive( subCondition );
                                        }
                                    }
                                    else if ( condition.leftExpression && !additionalDependingOnDataDescriptors.find( aDODD => aDODD.alias === condition.leftExpression ) ) {
                                        additionalDependingOnDataDescriptors.push(
                                            buildDataDescriptor(
                                                {
                                                    queryFieldName: condition.leftExpression
                                                },
                                                dataStructure
                                            ) as StaticDataDescriptor
                                        );
                                    }

                                    if ( condition.rightExpressionDataDescriptor && !additionalDependingOnDataDescriptors.find( aDODD => aDODD.alias === condition.rightExpressionDataDescriptor!.alias ) ) {
                                        additionalDependingOnDataDescriptors.push( condition.rightExpressionDataDescriptor );
                                    }
                                    if ( Array.isArray( condition.rightExpression ) ) {
                                        for ( const subCondition of condition.rightExpression ) {
                                            extractStylingFieldNamesRecursive( subCondition );
                                        }
                                    }
                                    else if ( condition.rightExpression && !additionalDependingOnDataDescriptors.find( aDODD => aDODD.alias === condition.rightExpression ) ) {
                                        additionalDependingOnDataDescriptors.push(
                                            buildDataDescriptor(
                                                {
                                                    queryFieldName: condition.rightExpression
                                                },
                                                dataStructure
                                            ) as StaticDataDescriptor
                                        );
                                    }
                                };

                                for ( const style of columnProps.styling ) {
                                    if ( style.condition ) {
                                        extractStylingFieldNamesRecursive( style.condition );
                                    }
                                }
                            }

                            // get dataDescriptors used in tooltip
                            if ( columnDefinition.tooltip && columnDefinition.dataDescriptor?.dataObject ) {
                                const tooltip           = typeof columnDefinition.tooltip === 'string' ? columnDefinition.tooltip : columnDefinition.tooltip.key,
                                      translatedTooltip = __( tooltip ),
                                      placeholders      = translatedTooltip.match( /\$\{[^}]*}/g )?.map( p => p.replace( '${', '' ).replace( '}', '' ) ) ?? [],
                                      rootDataObject    = {
                                          ...dataStructure,
                                          dataSelectionMode: 'all',
                                          dataStructure    : undefined
                                      } as DataObject;

                                for ( const placeholder of placeholders ) {
                                    const label = placeholder.split( '.' )[ 0 ];

                                    let dataObject : DataObject | undefined;

                                    if ( label === 'item' || label === 'property' || label === 'reference' || label === 'referenceProperty' ) {
                                        dataObject = rootDataObject;
                                    }
                                    else if ( typeof columnDefinition.tooltip !== 'string' ) {
                                        dataObject = columnDefinition.tooltip.dataObjects[ label ];
                                    }

                                    if ( dataObject ) {
                                        const placeholderDataDescriptor = buildDataDescriptor( { attributePath: placeholder }, dataObject );

                                        if ( placeholderDataDescriptor && !additionalDependingOnDataDescriptors.find( aDODD => aDODD.alias === placeholderDataDescriptor.alias ) ) {
                                            additionalDependingOnDataDescriptors.push( placeholderDataDescriptor );
                                        }
                                    }
                                }
                            }

                            for ( let i = 0; i < value.length; i++ ) {
                                const rowData = value[ i ],
                                      rowId   = `row_${i}`;

                                if ( !this.dataTableValue[ i ] ) {
                                    this.dataTableValue[ i ] = {
                                        rowData
                                    };

                                    if ( dataKey ) {
                                        this.dataTableValue[ i ][ dataKey ] = rowData[ dataKey ];
                                    }
                                    if ( groupRowsBy ) {
                                        this.dataTableValue[ i ][ groupRowsBy ] = rowData[ groupRowsBy ];
                                    }
                                }
                                else if ( this.dataTableValue[ i ].rowData !== rowData ) {
                                    this.dataTableValue[ i ] = {
                                        ...this.dataTableValue[ i ],
                                        rowData
                                    };
                                }

                                // on a pure cell-editor update, skip cells whose cellId
                                // isn't in the touched set — avoids getCellValue / cacheParameters
                                // / getDiffKeys for every other row
                                if ( onlyChangedCellIds ) {
                                    const cellIdForRow = DataTable.getCellId( i, columnField, rowData, columnDefinition.dataDescriptor, nextProps );

                                    if ( !onlyChangedCellIds.has( cellIdForRow ) ) {
                                        continue;
                                    }
                                }

                                const cellValue = this.getCellValue( columnField, rowData, nextProps );

                                if ( cellValue ) {
                                    let additionalDependingOnValues : string = '';

                                    for ( const additionalDependingOnDataDescriptor of additionalDependingOnDataDescriptors ) {
                                        if ( additionalDependingOnDataDescriptor.type !== 'static' && additionalDependingOnDataDescriptor.type !== 'expression' && additionalDependingOnDataDescriptor.dataObject ) {
                                            const rowRootItemIdDataDescriptor = buildDataDescriptor( { attributePath: 'item.id' }, dataStructure ) as ItemDataDescriptor,
                                                  rowRootItemId               = rowData[ rowRootItemIdDataDescriptor?.alias ],
                                                  data                        = dataUtils.getData( additionalDependingOnDataDescriptor, dataStructure, dataContext, rowRootItemId ),
                                                  additionalValue             = data?.[ 0 ] && data[ 0 ].type !== 'propertySet' && data[ 0 ].type !== 'referencePropertySet' ? dataUtils.getValueFromData( additionalDependingOnDataDescriptor, data[ 0 ] ) : undefined;

                                            if ( additionalValue ) {
                                                additionalDependingOnValues += `__${additionalValue}`;
                                            }
                                        }
                                        else {
                                            const additionalValue = this.getCellValue( additionalDependingOnDataDescriptor.alias, rowData, nextProps );

                                            if ( additionalValue ) {
                                                additionalDependingOnValues += `__${additionalValue.value}`;
                                            }
                                        }
                                    }

                                    cacheParameters = {
                                        schema,
                                        columnDefinition,
                                        columnConfiguration,
                                        timezone,
                                        rawMode,
                                        showAdditionalRawNames,
                                        showPropertyDefaults,
                                        editMode,
                                        language,
                                        messageCatalogTimestamp,
                                        //
                                        filterValue        : columnFilterValue,
                                        additionalDependingOnValues,
                                        value              : cellValue.value,
                                        initialValue       : cellValue.initialValue,
                                        editValue          : cellValue.editValue,
                                        editorErrorMessages: cellValue.editorErrorMessages,
                                        statusId           : cellValue.statusId,
                                        isEditable         : cellValue.isEditable,
                                        isDefault          : cellValue.isDefault,
                                        isNew              : cellValue.isNew,
                                        isModified         : cellValue.isModified,
                                        isDeleted          : cellValue.isDeleted
                                    };
                                    cacheParameterDiff = objectUtils.getDiffKeys( columnsCache?.[ columnField ]?.cellCache?.[ rowId ]?.cacheParameters ?? {}, cacheParameters, [ 'columnDefinition', 'columnConfiguration', 'editorErrorMessages' ] );

                                    if ( cacheParameterDiff.length ) {
                                        if ( this.debug ) {
                                            console.log( '       -> render cell', columnField, i );
                                        }

                                        columnsCache = {
                                            ...columnsCache,
                                            [ columnField ]: {
                                                columnCache: columnsCache?.[ columnField ]?.columnCache ?? {},
                                                filterCache: columnsCache?.[ columnField ]?.filterCache ?? {},
                                                cellCache  : {
                                                    ...columnsCache?.[ columnField ]?.cellCache,
                                                    [ rowId ]: {
                                                        cacheParameters,
                                                        body: this.buildCell(
                                                            nextProps,
                                                            columnDefinition,
                                                            columnProps,
                                                            columnField,
                                                            cellValue,
                                                            rowData,
                                                            i
                                                        )
                                                    }
                                                }
                                            }
                                        };
                                    }

                                    if ( columnsCache?.[ columnField ] && this.dataTableValue[ i ][ columnField ] !== columnsCache[ columnField ].cellCache?.[ rowId ]?.body ) {
                                        this.dataTableValue[ i ][ columnField ] = columnsCache[ columnField ].cellCache[ rowId ].body;
                                    }
                                }
                            }

                            // cleanup
                            this.dataTableValue.splice( value.length );
                            if ( columnsCache ) {
                                for ( const field of Object.keys( columnsCache ) ) {
                                    let i = value.length;

                                    while ( columnsCache[ field ].cellCache?.[ `row_${i}` ] ) {
                                        delete columnsCache[ field ].cellCache[ `row_${i}` ];
                                        i++;
                                    }
                                }
                            }
                        }
                    }
                }

                if ( columnsCache !== elusiveData?.columnsCache ) {
                    this.props.setElusiveData( uid, { columnsCache } );
                }
            }

            if ( !this.renderedColumns && columnsCache ) {
                if ( this.debug ) {
                    console.log( '   -> build renderedColumns' );
                }

                this.renderedColumns = columns.map( column => columnsCache![ column.field ]?.columnCache.column );

                if ( Object.values( nextProps.actionColumns ).length ) {
                    this.renderedColumns = ( Object.values( nextProps.actionColumns ).map( actionColumn => actionColumn.column ) as React.ReactNode[] ).concat( this.renderedColumns );
                }

                retVal = true;
            }

            if ( !this.renderedFilters && columnsCache ) {
                if ( this.debug ) {
                    console.log( '   -> build renderedFilters' );
                }

                this.renderedFilters = {};

                for ( const field of Object.keys( columnsCache ) ) {
                    if ( columnsCache[ field ].filterCache.filter ) {
                        this.renderedFilters[ field ] = columnsCache[ field ].filterCache.filter;
                    }
                }

                retVal = true;
            }

            // handle forceFit and autoLayout
            if ( !this.handleForceFitOrAutoLayout( nextProps ) ) {
                retVal = true;
            }

            // update errorData
            if ( changedProps.includes( 'elusiveData.cellEditorErrors' ) ) {
                if ( this.debug ) {
                    console.log( '   -> build errorData' );
                }

                const cellErrors                                = nextProps.elusiveData?.cellEditorErrors ?? {},
                      cellIds                                   = Object.keys( cellErrors ),
                      errorData : PanelErrorData[ 'errorData' ] = {
                          count  : cellIds.length,
                          tooltip: [],
                          message: []
                      };

                for ( const cellId of cellIds ) {
                    const cellError        = cellErrors[ cellId ],
                          columnIndex      = nextProps.columns.findIndex( col => col.field === cellError.field ) + 1,
                          columnDefinition = nextProps.columnDefinitions.find( colDef => colDef.field === cellError.field ) as ColumnDefinition;

                    if ( columnIndex ) {
                        const title    = __( 'YN.base.frontend.dataTable.error.detail.header', {
                                  columnIndex : String( columnIndex ),
                                  columnHeader: __( columnDefinition.header ?? '' ),
                                  rowIndex    : String( cellError.rowIndex )
                              } ),
                              messages = cellError.messages.map( message => <>{message}<br/></> );

                        errorData.tooltip!.push( <div className="yn-tooltip-subheader">{title}</div> );
                        errorData.tooltip!.push( <>{messages}</> );

                        if ( errorData.message!.length ) {
                            errorData.message!.push( <hr className="yn-error-ruler"/> );
                        }
                        errorData.message!.push( <div className="yn-error-subtitle">{title}</div> );
                        errorData.message!.push( <div className="yn-error-message">{messages}</div> );
                    }
                }
                this.props.setElusiveData( this.props.uid, {
                    errorData
                } );

                retVal = false;
            }

            // search
            if ( nextProps.doSearch ) {
                const applyableFilters = nextProps.getApplyableFilters
                    ? nextProps.getApplyableFilters( nextProps )
                    : ( [] as ColumnFilter[] )
                        .concat( nextProps.fixFilters )
                        .concat( nextProps.elusiveData?.newFilters ?? nextProps.filters );

                if ( this.debug ) {
                    console.log( '   -> search' );
                }

                this.dataTableValue = [];
                if ( columnsCache ) {
                    for ( const field of Object.keys( columnsCache ) ) {
                        columnsCache[ field ].cellCache = {};
                    }

                    this.props.setElusiveData( this.props.uid, { columnsCache } );
                }

                // changed filters, sorters or searchString -> resetSearch
                if (
                    nextProps.ownElusiveData?.lastParams
                    && typeof nextProps.ownElusiveData.lastParams === 'object'
                    && Object.keys( nextProps.ownElusiveData.lastParams ).length
                    && (
                        ( nextProps.ownElusiveData.lastParams.searchString ?? '' ) !== ( nextProps.searchString ?? '' )
                        || !_.isEqual( this.props.columns, nextProps.columns )
                        || !_.isEqual( nextProps.ownElusiveData.lastParams.filters, applyableFilters )
                        || !_.isEqual( nextProps.ownElusiveData.lastParams.sorters, nextProps.sorters )
                    )
                ) {
                    this.props.setParam( this.props.uid, 'doSearch', true );
                    this.props.setParam( this.props.uid, 'filters', nextProps.elusiveData?.newFilters ?? nextProps.filters );
                    this.props.setElusiveData( this.props.uid, { newFilters: undefined } );
                    this.props.resetSearch( this.props.uid );
                }
                else {
                    this.props.setParam( this.props.uid, 'doSearch', false );
                    if ( this.reload( nextProps ) ) {
                        this.props.setParam( this.props.uid, 'search', true );
                    }
                    else {
                        this.props.unsetParam( uid, 'search' );
                    }
                }

                retVal = false;
            }
        }

        if ( this.debug ) {
            console.log( '    retVal', retVal );
            console.log( `${Math.round( 1000 * ( performance.now() - startTime ) ) / 1000} ms`.asLogLine( 100 ) );
        }

        return retVal;
    }


    /* event handlers *********************************************************************************************************************/

    /**
     * Handler for DataTable sort event.
     *
     * @param {DataTableStateEvent} event
     *
     * @private
     */
    onSort( event : DataTableStateEvent ) {
        const {
                  uid,
                  columns
              }                        = this.props,
              sorters : ColumnSorter[] = [];

        if ( event.multiSortMeta ) {
            for ( const sortDefinition of event.multiSortMeta ) {
                const column = columns.find( col => sortDefinition.field === col.field );

                if ( column ) {
                    sorters.push( {
                        key      : column.key,
                        field    : column.field,
                        direction: ( sortDefinition.order === 1
                            ? 'ASC'
                            : 'DESC' ) as SortDirection
                    } );
                }
            }

            this.props.setParam( uid, 'sorters', sorters );
            if ( this.props.search ) {
                this.props.setParam( uid, 'doSearch', true );
            }
        }
    }

    /**
     * Handler for DataTable columnResizeEnd event.
     *
     * @param {DataTableColumnResizeEndEvent} event
     *
     * @private
     */
    onColumnResizeEnd( event : DataTableColumnResizeEndEvent ) {
        const {
                  uid,
                  actionColumns
              }                        = this.props,
              columns : ColumnConfig[] = [ ...this.props.columns ],
              actionColumnsCount       = Object.keys( actionColumns ).length,
              columnIndex              = columns.findIndex( column => column.field === event.column.props.field );

        let applied : boolean = false;

        if ( columnIndex >= 0 ) {
            const columnElement = document.querySelector( `#${uid}_datatable .yn-header-column:nth-child(${1 + columnIndex + actionColumnsCount})` ) as HTMLElement;

            let newWidth = columnElement?.offsetWidth;

            if ( !newWidth ) {
                const column = { ...columns[ columnIndex ] };

                newWidth = ( ( column.width === 'auto' ? 150 : column.width ) ?? 0 ) + event.delta;
            }

            if ( newWidth && columns[ columnIndex ].resizeable !== false && columns[ columnIndex ].width !== newWidth ) {
                columns[ columnIndex ] = {
                    ...columns[ columnIndex ],
                    width: newWidth
                };

                this.props.setParam( uid, 'columns', columns );

                applied = true;
            }
        }

        if ( !applied ) {
            this.dataTable?.resetResizeColumnsWidth();
        }

        this.columnResizeHandled = true;
    }

    /**
     * Handler for DataTable colReorder event.
     *
     * @param {DataTableColReorderEvent} event
     *
     * @private
     */
    onColReorder( event : DataTableColReorderEvent ) {
        const {
                  uid
              }                        = this.props,
              columns : ColumnConfig[] = [].concat( this.props.columns as [] );

        columns.splice( event.dropIndex, 0, columns.splice( event.dragIndex, 1 )[ 0 ] );

        this.props.setParam( uid, 'columns', columns );
    }

    /**
     * Handler for DataTable page event.
     *
     * @param event
     *
     * @private
     */
    onPage( event : DataTableStateEvent ) {
        const page = ( event.first / event.rows ) + 1,
              rows = event.rows;

        if ( this.props.page !== page || this.props.rows !== rows ) {
            this.props.setPaginationData( this.props.uid, page, rows );
        }
    }

    onClick() {
        if ( this.notSelectable || ( !this.justSelected && !this.props.elusiveData?.editCell ) ) {
            this.props.unsetParam( this.props.uid, 'selection' );
        }

        this.notSelectable = false;
        this.justSelected = false;
    }

    /**
     * Handler for selection
     *
     * @param {DataTableSelectionSingleChangeEvent<RowData[]>} event
     */
    onSelectionChange( event : DataTableSelectionSingleChangeEvent<RowData[]> ) {
        let selection : any | any[];

        this.justSelected = true;

        if ( event.type === 'single' ) {
            const values = !Array.isArray( event.value ) ? [ event.value ] : event.value;

            selection = [];

            for ( const value of values ) {
                const {
                          uid,
                          schema,
                          dataContext,
                          dataStructure,
                          value: rowDatas,
                          columnDefinitions
                      }                = this.props,
                      rowData          = rowDatas?.[ value.rowIndex ],
                      columnDefinition = columnDefinitions.find( colDef => colDef.field === value.field ),
                      dataDescriptor   = columnDefinition?.dataDescriptor,
                      permissions      = columnDefinition?.permissions,
                      cellId           = DataTable.getCellId( value.rowIndex, value.field, rowData, dataDescriptor, this.props );

                if ( dataDescriptor && cellId ) {
                    const rows                            = document.querySelectorAll( `#${uid}_datatable .p-datatable-tbody tr` ),
                          additionalCheckParameters : any = {};

                    if ( rowData && dataDescriptor.type === 'reference' ) {
                        const reference = getReferenceForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        additionalCheckParameters.referenceSetId = reference?.referenceSetId;
                    }

                    for ( let i = 0; i < rows.length; i++ ) {
                        if ( isColumnEditable( dataDescriptor, dataStructure, schema, permissions, additionalCheckParameters ) && ( rows[ i ].querySelector( `#cell_${cellId}_${i}` ) ?? rows[ i ].querySelector( `#cellEditor_${cellId}_${i}` ) ) ) {
                            selection.push( {
                                rowData  : value.rowData,
                                field    : value.field,
                                rowIndex : i,
                                cellIndex: value.cellIndex
                            } );
                        }
                    }
                }
            }
        }
        else {
            selection = event.value;
        }

        this.props.setParam( this.props.uid, 'selection', selection );

    }

    /**
     * Handler for row expander toggle
     *
     * @param {DataTableRowToggleEvent} event
     */
    onRowToggle( event : DataTableRowToggleEvent ) {
        const { groupRowsBy } = this.props;

        let expandedRows : DataTableRowToggleEvent[ 'data' ] = [];

        if ( groupRowsBy ) {

            // any[]
            if ( Array.isArray( event.data ) ) {
                for ( const expandedRow of event.data ) {
                    const groupRowsByValuePath = groupRowsBy.split( '.' );

                    let groupRowsByValue : any | undefined = undefined,
                        data                               = expandedRow;

                    while ( groupRowsByValuePath.length && data ) {
                        data = data[ groupRowsByValuePath.shift() as keyof typeof data ];
                    }
                    groupRowsByValue = data;

                    if ( groupRowsByValue === undefined ) {
                        groupRowsByValue = groupRowsByValue = expandedRow[ groupRowsBy ];
                    }

                    const index = expandedRows.indexOf( groupRowsByValue );

                    if ( index === -1 ) {
                        expandedRows.push( groupRowsByValue );
                    }
                    else {
                        expandedRows.splice( index, 1 );
                    }
                }

                expandedRows = expandedRows.map(
                    ( groupRowsByValue ) => {
                        return {
                            [ groupRowsBy ]: groupRowsByValue
                        }
                    }
                );
            }

            // DataTableExpandedRows ( { [key: string]: boolean; } )
            else {
                for ( const groupRowsByValue of Object.keys( event.data ) ) {
                    const index = expandedRows.indexOf( groupRowsByValue );

                    if ( event.data[ groupRowsByValue ] && index === -1 ) {
                        expandedRows.push( groupRowsByValue )
                    }
                    else if ( !event.data[ groupRowsByValue ] && index !== -1 ) {
                        expandedRows.splice( index, 1 );
                    }
                }

                expandedRows = expandedRows.reduce(
                    ( reducedExpandedRows, groupRowsByValue ) => {
                        reducedExpandedRows[ groupRowsByValue ] = true;
                        return reducedExpandedRows;
                    },
                    {}
                );
            }

            this.props.setParam( this.props.uid, 'expandedRows', expandedRows );
        }
        else {
            this.props.setParam( this.props.uid, 'expandedRows', event.data );
        }
    }

    /**
     * Handler for DataTable rowClick event.
     *
     * @private
     */
    onRowClick( event : DataTableRowClickEvent ) {
        if ( !this.props.editMode ) {
            const rowData   = event.data.rowData,
                  { field } = this.getKeyAndFieldForMouseEvent( event.originalEvent );

            if ( field && rowData ) {
                const mouseEvent = event.originalEvent as unknown as React.MouseEvent<HTMLElement>;

                if ( !this.props.onRowClick?.( field, rowData, mouseEvent ) ) {
                    this.openDetailPanelForCell( rowData, mouseEvent );
                }
            }
        }
    }

    /**
     * Handler for dataTable contextMenuSelectionChange
     *
     * @private
     */
    onContextMenuSelectionChange( event : DataTableContextMenuSingleSelectionChangeEvent<RowData[]> ) {
        const rowData = event.value as unknown as RowData,
              {
                  key  : columnKey,
                  field: columnField
              }       = this.getKeyAndFieldForMouseEvent( event.originalEvent as unknown as React.MouseEvent<HTMLElement> );

        if ( columnKey && columnField ) {
            this.setState( {
                contextMenuSelection: event.value,
                contextMenuCellInfo : {
                    columnKey,
                    columnField,
                    rowData
                }
            } );
        }
    }

    /**
     * Handler for dataTable contextMenu
     *
     * @private
     */
    onContextMenu( event : DataTableRowEvent ) {
        this.contextMenuRef?.show( event.originalEvent );
    }

    /**
     * Handler for contextMenu hide
     *
     * @private
     */
    onContextMenuHide() {
        this.setState( {
            contextMenuSelection: undefined,
            contextMenuCellInfo : undefined
        } );
    }

    /**
     * Handler for column editor beforeShow
     *
     * @private
     */
    onBeforeCellEditShow( columnEditorProps : ColumnEditorProps, params : ColumnEvent ) {
        const {
                  uid,
                  schema,
                  dataContext,
                  editMode,
                  dataStructure,
                  value,
                  elusiveData
              }                 = this.props,
              {
                  field,
                  dataDescriptor,
                  permissions,
                  defaultValue,
                  valueType
              }                 = columnEditorProps,
              rowData           = this.dataTableValue[ params.rowIndex ].rowData,
              changedCellValues = { ...elusiveData?.changedCellValues ?? {} };

        let retVal : boolean = false;

        // editMode and editable?
        if ( editMode && Object.keys( dataStructure ).length && dataDescriptor && permissions ) {
            const additionalCheckParameters : any = {};

            if ( dataDescriptor.type === 'reference' ) {
                const reference = getReferenceForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                additionalCheckParameters.referenceSetId = reference?.referenceSetId;
            }

            if ( isColumnEditable( dataDescriptor, dataStructure, schema, permissions, additionalCheckParameters ) ) {
                retVal = true;

                // setting boolean value directly and deny editing
                if (
                    ( dataDescriptor.type === 'property' || dataDescriptor.type === 'referenceProperty' )
                    && dataDescriptor.attribute === 'value'
                ) {
                    const notSettableStatus = [
                        metaModel[ schema ].getStatus( 'history' )?.id,
                        metaModel[ schema ].getStatus( 'deleted' )?.id
                    ];

                    // property
                    if ( dataDescriptor.type === 'property' ) {
                        const item     = getItemForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData ),
                              property = getPropertyForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        if ( item && !notSettableStatus.includes( item.statusId ) ) {

                            // modify existing
                            if ( property?.propertySet.valueType === 'BOOLEAN' ) {
                                if ( property.propertySet.isEnumerated ) {
                                    this.setEnumPropertyAttributes( property.itemId, property.propertySet.propertyTypeId, property.stringKey, { value: !property.value } );
                                }
                                else {
                                    this.setPropertyAttributes( property.itemId, property.propertySet.propertyTypeId, { value: !property.value } );
                                }

                                retVal = false;
                            }

                            // add new
                            else if ( !property && Object.keys( dataStructure ).length ) {
                                const propertySet = dataDescriptor.dataObject.item.objectType
                                    ? metaModel[ schema ].getPropertySetForItemTypeAndPropertyType( dataDescriptor.dataObject.item.objectType, dataDescriptor.propertyTypeName )
                                    : undefined;

                                if ( propertySet?.valueType === 'BOOLEAN' ) {
                                    if ( propertySet.isEnumerated ) {
                                        this.setEnumPropertyAttributes( item.id, propertySet.propertyTypeId, '', { value: _.isBoolean( propertySet.valueDefault ) ? !propertySet.valueDefault : true } );
                                    }
                                    else {
                                        this.setPropertyAttributes( item.id, propertySet.propertyTypeId, { value: _.isBoolean( propertySet.valueDefault ) ? !propertySet.valueDefault : true } );
                                    }

                                    retVal = false;
                                }
                            }
                        }
                    }

                    // referenceProperty
                    else {
                        const reference         = getReferenceForDataDescriptorFromRowData( dataContext, dataDescriptor, dataStructure ),
                              referenceProperty = getReferencePropertyForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        if ( reference && !notSettableStatus.includes( reference.statusId ) ) {

                            // modify existing
                            if ( referenceProperty?.referencePropertySet.valueType === 'BOOLEAN' ) {
                                if ( referenceProperty.referencePropertySet.isEnumerated ) {
                                    this.setEnumReferencePropertyAttributes( referenceProperty.referenceId, referenceProperty.referencePropertySet.propertyTypeId, referenceProperty.stringKey, { value: !referenceProperty.value } );
                                }
                                else {
                                    this.setReferencePropertyAttributes( referenceProperty.referenceId, referenceProperty.referencePropertySet.propertyTypeId, { value: !referenceProperty.value } );
                                }

                                retVal = false;
                            }

                            // add new
                            else if ( !referenceProperty && Object.keys( dataStructure ).length ) {
                                const referencePropertySet = metaModel[ schema ].getReferencePropertySetForReferenceSetAndPropertyType( reference.referenceSetId, dataDescriptor.propertyTypeName );

                                if ( reference && referencePropertySet?.valueType === 'BOOLEAN' ) {
                                    if ( referencePropertySet.isEnumerated ) {
                                        this.setEnumReferencePropertyAttributes( reference.id, referencePropertySet.propertyTypeId, '', { value: _.isBoolean( referencePropertySet.valueDefault ) ? referencePropertySet.valueDefault : true } );
                                    }
                                    else {
                                        this.setReferencePropertyAttributes( reference.id, referencePropertySet.propertyTypeId, { value: _.isBoolean( referencePropertySet.valueDefault ) ? referencePropertySet.valueDefault : true } );
                                    }

                                    retVal = false;
                                }
                            }
                        }
                    }
                }
                else if ( dataDescriptor.type === 'static' && valueType === 'BOOLEAN' ) {
                    const cellValue = this.getCellValue( field, rowData ),
                          rowId     = DataTable.getRowId( rowData ),
                          editValue = convertValueForType( changedCellValues[ rowId ]?.[ field ] ?? cellValue?.initialValue ?? rowData[ field ], 'BOOLEAN' ) ? 'false' : 'true';

                    retVal = false;

                    if ( editValue !== cellValue?.initialValue ) {
                        changedCellValues[ rowId ] = {
                            ...changedCellValues[ rowId ],
                            [ field ]: editValue
                        };

                        void this.props.onRowDataChange?.( field, editValue, { ...rowData }, params.originalEvent, changedCellValues );
                    }
                    else {
                        if ( changedCellValues[ rowId ] ) {
                            delete changedCellValues[ rowId ][ field ];

                            if ( !Object.keys( changedCellValues[ rowId ] ).length ) {
                                delete changedCellValues[ rowId ];
                            }
                        }

                        void this.props.onRowDataRevert?.( field, { ...rowData }, params.originalEvent, changedCellValues );
                    }

                    this.props.setElusiveData( uid, {
                        changedCellValues
                    } );
                }

                // init editValue and editing cell
                if ( retVal ) {
                    const cellValue = this.getCellValue( field, rowData );

                    if ( cellValue?.isEditable ) {
                        const cellEditorInitialValues = { ...elusiveData?.cellEditorInitialValues ?? {} };

                        let cellEditorValues = elusiveData?.cellEditorValues ?? {};

                        // edit cell
                        const editCell = {
                            cellId  : cellValue.cellId,
                            field,
                            rowIndex: value?.findIndex( valueRowData => valueRowData === rowData ) ?? -1
                        };

                        // get editValue
                        let editValue = cellValue.editValue ?? cellValue.value;

                        // default value
                        if ( editValue === undefined && defaultValue !== undefined ) {
                            editValue = defaultValue;

                            // set to elusive data to enforce saving unedited editValue
                            cellEditorValues = { ...cellEditorValues };
                            cellEditorValues[ cellValue.cellId ] = defaultValue;
                        }

                        // initial Value
                        cellEditorInitialValues[ cellValue.cellId ] = editValue;

                        this.props.setElusiveData( uid, {
                            editCell,
                            cellEditorValues,
                            cellEditorInitialValues
                        } );
                    }
                    else {
                        retVal = false;
                    }
                }
            }
        }

        if ( !retVal ) {
            this.notSelectable = true;
        }

        return retVal;
    }

    /**
     * Handler for column editor cancel
     *
     * @private
     */
    onCellEditCancel( columnEditorProps : ColumnEditorProps, params : ColumnEvent ) {
        const {
                  uid,
                  value,
                  elusiveData
              }                               = this.props,
              editCell                        = { ...elusiveData?.editCell ?? {} },
              cellEditorValues                = { ...elusiveData?.cellEditorValues ?? {} },
              cellEditorInitialValues         = { ...elusiveData?.cellEditorInitialValues ?? {} },
              cellEditorErrors                = { ...elusiveData?.cellEditorErrors ?? {} },
              {
                  field
              }                               = columnEditorProps,
              rowData                         = this.dataTableValue[ params.rowIndex ].rowData,
              cellId                          = DataTable.getCellId( params.rowIndex, field, rowData, columnEditorProps.dataDescriptor, this.props ),
              initialValue                    = cellEditorInitialValues[ cellId ],
              cellEditorData : CellEditorData = {};

        // clear cell editor if
        if ( editCell.cellId === cellId ) {
            cellEditorData.editCell = undefined;
        }

        // clear initial value
        delete cellEditorInitialValues[ cellId ];
        cellEditorData.cellEditorInitialValues = cellEditorInitialValues;

        // reset edit value
        cellEditorValues[ cellId ] = initialValue;
        cellEditorData.cellEditorValues = cellEditorValues;

        // drop any pending debounced editor value — the edit was cancelled
        delete this.pendingEditorValues[ cellId ];

        // validate value
        const errors : ( string | JSX.Element | JSX.Element[] )[] = this.validateValueForCell( initialValue, field, rowData );
        // set error
        if ( errors.length ) {
            cellEditorErrors[ cellId ] = {
                field,
                rowIndex: value?.findIndex( valueRowData => valueRowData === rowData ) ?? -1,
                messages: errors
            };
        }
        // clear error
        else if ( cellEditorErrors[ cellId ] ) {
            delete cellEditorErrors[ cellId ];
        }
        cellEditorData.cellEditorErrors = cellEditorErrors;

        this.props.unsetParam( this.props.uid, 'selection' );
        this.props.setElusiveData( uid, cellEditorData );
    }

    /**
     * Handler for editor complete
     * Set the value to object
     *
     * @private
     */
    onCellEditComplete( columnEditorProps : ColumnEditorProps, params : ColumnEvent ) {
        const {
                  uid,
                  elusiveData
              }                                                                            = this.props,
              editCell                                                                     = { ...elusiveData?.editCell ?? {} },
              cellEditorValues                                                             = { ...elusiveData?.cellEditorValues ?? {} },
              cellEditorInitialValues                                                      = { ...elusiveData?.cellEditorInitialValues ?? {} },
              cellEditorErrors                                                             = { ...elusiveData?.cellEditorErrors ?? {} },
              changedCellValues                                                            = { ...elusiveData?.changedCellValues ?? {} },
              {
                  field
              }                                                                            = columnEditorProps,
              rowData                                                                      = this.dataTableValue[ params.rowIndex ].rowData,
              cellId                                                                       = DataTable.getCellId( params.rowIndex, field, rowData, columnEditorProps.dataDescriptor, this.props ),
              cellEditorData : CellEditorData & { changedCellValues? : ChangedCellValues } = {};

        // clear cell editor if
        if ( editCell.cellId === cellId ) {
            cellEditorData.editCell = undefined;
        }

        // clear initial value
        delete cellEditorInitialValues[ cellId ];
        cellEditorData.cellEditorInitialValues = cellEditorInitialValues;

        // prefer the instance cache: it carries the freshest value from a debounced
        // editor flush on blur, which may not have reached this.props yet
        if ( cellId in this.pendingEditorValues ) {
            cellEditorValues[ cellId ] = this.pendingEditorValues[ cellId ];
            cellEditorData.cellEditorValues = cellEditorValues;
        }
        delete this.pendingEditorValues[ cellId ];

        // save edit value
        if ( cellEditorValues[ cellId ] !== undefined && !cellEditorErrors[ cellId ]?.messages.length ) {
            const editValue          = cellEditorValues[ cellId ],
                  setCellValueResult = this.setCellValue(
                      editValue,
                      field,
                      rowData,
                      { cellEditorValues, cellEditorErrors, changedCellValues }
                  );

            if ( setCellValueResult !== false ) {
                cellEditorData.cellEditorValues = cellEditorValues;
                cellEditorData.cellEditorErrors = cellEditorErrors;
                cellEditorData.changedCellValues = changedCellValues;

                if ( setCellValueResult === 'change' ) {
                    void this.props.onRowDataChange?.( field, editValue, { ...rowData }, params.originalEvent, changedCellValues );
                }
                else if ( setCellValueResult === 'revert' ) {
                    void this.props.onRowDataRevert?.( field, { ...rowData }, params.originalEvent, changedCellValues );
                }
            }
        }

        this.props.unsetParam( uid, 'selection' );
        this.props.setElusiveData( uid, cellEditorData );
    }

    /**
     * Handler for editor resize
     *
     * @private
     */
    onCellEditorResize( field : string, width : number, _height : number ) {
        const columns = ( [] as ColumnConfig[] ).concat( this.props.columns );

        if ( columns?.length ) {
            for ( let i = 0; i < columns.length; i++ ) {
                if ( columns[ i ].field === field ) {
                    columns[ i ] = Object.assign( {}, columns[ i ] );
                    columns[ i ].width = width + 2;
                    break;
                }
            }

            this.props.setParam( this.props.uid, 'columns', columns );
        }
    }

    /**
     * Handler for column editor change
     *
     * @private
     */
    onEditorChange( columnEditorProps : ColumnEditorProps, columnProps : ColumnEditorOptions, rowData : LoadMetaDataRowData, editValue : any, _originalEvent : any ) {
        const {
                  uid,
                  value,
                  elusiveData
              }                               = this.props,
              cellEditorValues                = { ...elusiveData?.cellEditorValues ?? {} },
              cellEditorErrors                = { ...elusiveData?.cellEditorErrors ?? {} },
              {
                  field
              }                               = columnEditorProps,
              cellId                          = DataTable.getCellId( columnProps.rowIndex, field, rowData, columnEditorProps.dataDescriptor, this.props ),
              cellEditorData : CellEditorData = {};

        // set edit value
        cellEditorValues[ cellId ] = editValue ?? null;
        cellEditorData.cellEditorValues = cellEditorValues;

        // also mirror into the instance cache so onCellEditComplete can read the
        // latest value even when the redux update from setElusiveData hasn't yet
        // re-rendered (debounced editors flush via onBlur in the same React batch)
        this.pendingEditorValues[ cellId ] = editValue ?? null;

        // validate value
        const errors : ( string | JSX.Element | JSX.Element[] )[] = this.validateValueForCell( editValue, field, rowData );
        // set error
        if ( errors.length ) {
            const stringifiedRowData = JSON.stringify( rowData );

            cellEditorErrors[ cellId ] = {
                field,
                rowIndex: ( value?.findIndex( valueRowData => JSON.stringify( valueRowData ) === stringifiedRowData ) ?? -1 ) + 1,
                messages: errors
            };
        }
        // clear error
        else if ( cellEditorErrors[ cellId ] ) {
            delete cellEditorErrors[ cellId ];
        }
        cellEditorData.cellEditorErrors = cellEditorErrors;

        this.props.setElusiveData( uid, cellEditorData );
    }

    /**
     * Handler for column filter change
     *
     * @param key
     * @param {String} field
     * @param {FilterMatchMode} matchMode
     * @param {*} value
     * @param {ValueType} valueType
     *
     * @private
     */
    onFilterChange( _key : string, field : string, matchMode : FilterMatchMode, value : any, valueType : FilterValueType ) {
        const {
                  columnDefinitions,
                  filters,
                  fixFilters,
                  elusiveData
              }                               = this.props as AllProps,
              currentFilters : ColumnFilter[] = ( [] as ColumnFilter[] ).concat( elusiveData?.newFilters ?? filters ),
              columnDefinition                = columnDefinitions.find( colDef => field === colDef.field );

        let processed = false;

        // is fixFilter -> mark processed to avoid further processing
        for ( const fixFilter of fixFilters ) {
            if ( fixFilter.field === field ) {
                processed = true;
            }
        }

        // filter exists
        if ( !processed ) {
            for ( let i = 0; i < currentFilters.length; i++ ) {
                if ( currentFilters[ i ].field === field ) {
                    currentFilters[ i ] = Object.assign( {}, currentFilters[ i ] );
                    currentFilters[ i ].operator = matchMode;

                    if ( matchMode === 'empty' || matchMode === 'notEmpty' ) {
                        delete currentFilters[ i ].value;
                        delete currentFilters[ i ].valueType;
                    }
                    else if ( value !== '' ) {
                        currentFilters[ i ].value = value;
                        currentFilters[ i ].valueType = valueType;
                    }
                    else {
                        currentFilters.splice( i, 1 );
                    }

                    processed = true;
                    break;
                }
            }
        }

        // filter not exists -> add
        if ( !processed && columnDefinition ) {
            const newFilter = {
                key     : columnDefinition.key,
                field   : columnDefinition.field,
                operator: matchMode
            } as ColumnFilter;

            if ( matchMode !== 'empty' && matchMode !== 'notEmpty' ) {
                newFilter.value = value;
                newFilter.valueType = valueType;
            }

            currentFilters.push( newFilter );
        }

        if ( !_.isEqual( currentFilters, elusiveData?.newFilters ) ) {
            this.props.setElusiveData( this.props.uid, { newFilters: currentFilters } );
        }
    }

    /**
     * Handler for column filter enterKey
     *
     * @private
     */
    onFilterEnterKey() {
        this.props.setParam( this.props.uid, 'doSearch', true );
    }

    /**
     * Handler for DataTable rowClass callback.
     *
     * @param {any} rowData
     *
     * @return {{ [ className : string ] : boolean }}
     *
     * @private
     */
    onResolveRowClass( rowData : LoadMetaDataRowData ) : { [ className : string ] : boolean } {
        const retVal : {
                  [ className : string ] : boolean
              }         = this.props.rowClass?.( rowData.rowData ) ?? {},
              {
                  rowStyling
              }         = this.props,
              rowValues = this.getRowValues( rowData.rowData ),
              rowState  = this.props.rowState?.( rowData.rowData );

        if ( rowState === 'inserted' ) {
            retVal[ 'yn-added' ] = true;
        }
        else if ( rowState === 'modified' ) {
            retVal[ 'yn-modified' ] = true;
        }
        else if ( rowState === 'deleted' ) {
            retVal[ 'yn-deleted' ] = true;
        }

        if ( rowStyling ) {
            const classNames = resolveStyleToClassNames( rowStyling, rowValues, 'row', [ '.p-datatable .p-datatable-tbody > tr.${className}', '.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd.${className}', '.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd.${className} + tr.p-row-expanded' ] );

            for ( const className of classNames ) {
                retVal[ className ] = true;
            }
        }

        return retVal;
    }

    onColumnHeaderClick( columnDefinition : ColumnDefinition, event : React.MouseEvent ) {
        if ( !this.columnResizeHandled && !this.columnResizeDrag && ( event.target as HTMLElement ).closest( '.yn-header-column' ) ) {

            // click?
            if ( !this.clickTimeout ) {
                this.clickTimeout = window.setTimeout(
                    () => {
                        this.clickTimeout = 0;
                        this.handleHeaderClick( columnDefinition, event.metaKey );
                    },
                    200
                );
            }

            // double click
            else {
                window.clearTimeout( this.clickTimeout );
                this.clickTimeout = 0;

                this.handleHeaderDoubleClick( columnDefinition, event.metaKey );
            }

            event.preventDefault();
            event.stopPropagation();
        }

        this.columnResizeHandled = false;
    }

    onColumnResizeDragStart() {
        this.columnResizeDrag = true;
    }

    onColumnResizeDragEnd() {
        // delay reset so onColumnResizeEnd fires first and sets columnResizeHandled = true,
        // preventing a spurious sort triggered by the header click handler
        requestAnimationFrame( () => {
            this.columnResizeDrag = false;
        } );
    }

    /* private ****************************************************************************************************************************/

    /**
     * Init
     *
     * @private
     */
    init() {
        document.addEventListener( 'scroll', this.debouncedGetScrollPosition, true );
        document.addEventListener( 'resize', this.updateFullTableWidthAndTableHeaderHeight, true );

        this.doSetScrollPosition = true;

        this.props.setParam( this.props.uid, 'moduleTransformer', 'dataTable' );

        const {
                  search,
                  ownElusiveData
              } = this.props as AllProps;

        // force caching
        if ( !this.renderedColumns ) {
            this.setState( { cacheToggle: !this.state.cacheToggle } );
        }

        // start search if
        if ( ( search && !ownElusiveData?.lastParams ) || ( ownElusiveData?.lastParams && !global.data[ this.props.dataContext ] ) ) {
            this.props.setParam( this.props.uid, 'doSearch', false );
            this.reload( this.props );
        }

        this.afterRender();
    }

    reload( props : AllProps = this.props ) {
        const filters = props.elusiveData?.newFilters ?? props.filters;

        this.props.setParam( this.props.uid, 'scrollTop', 0 );
        this.doSetScrollPosition = true;

        this.props.setParam( this.props.uid, 'filters', filters );
        this.props.setElusiveData( this.props.uid, { newFilters: undefined } );

        return this.props.reload( {
            ...props,
            filters
        } );
    }

    cleanup() {
        document.removeEventListener( 'scroll', this.debouncedGetScrollPosition, true );
        document.removeEventListener( 'resize', this.updateFullTableWidthAndTableHeaderHeight, true );

        if ( this.clickTimeout ) {
            window.clearTimeout( this.clickTimeout );
        }

        this.getScrollPosition();
    }

    setScrollPosition() {
        if ( this.doSetScrollPosition ) {
            const { uid }        = this.props,
                  dataTable      = document.getElementById( `${uid}_datatable` ),
                  scrollSelector = dataTable?.getAttribute( 'data-scrollselectors' ) ?? 'nothing',
                  scrollElement  = dataTable?.querySelector( scrollSelector );

            if ( scrollElement ) {
                scrollElement.scrollLeft = this.props.scrollLeft;
                scrollElement.scrollTop = this.props.scrollTop;

                if ( ( this.props.scrollLeft === 0 || scrollElement.scrollLeft > 0 ) && ( this.props.scrollTop === 0 || scrollElement.scrollTop > 0 ) ) {
                    this.doSetScrollPosition = false;
                }
            }
        }
    }

    getScrollPosition() {
        if ( !this.doSetScrollPosition ) {
            const { uid }        = this.props,
                  dataTable      = document.getElementById( `${uid}_datatable` ),
                  scrollSelector = dataTable?.getAttribute( 'data-scrollselectors' ) ?? 'nothing',
                  scrollElement  = dataTable?.querySelector( scrollSelector );

            if ( scrollElement ) {
                this.props.setParam( uid, 'scrollLeft', scrollElement.scrollLeft ?? 0 );
                this.props.setParam( uid, 'scrollTop', scrollElement.scrollTop ?? 0 );
            }
        }
    }

    afterRender() {
        if ( this.debug ) {
            console.log( `DataTable - render - ${Math.round( 1000 * ( performance.now() - this.renderStartTime ) ) / 1000} ms`.asLogLine( 100 ) );
        }

        if ( this.columnOrderReset ) {
            this.columnOrderReset = false;
            // has to happen after the render - it updates PrimeReacts own state
            this.dataTable?.resetColumnOrder();
        }

        this.setScrollPosition();

        this.handleForceFitOrAutoLayout( this.props );

        this.updateFullTableWidthAndTableHeaderHeight();
    }

    handleHeaderClick( columnDefinition : ColumnDefinition, append : boolean = false ) {
        const {
                  uid,
                  search
              } = this.props;

        let sorters = ( [] as ColumnSorter[] ).concat( this.props.sorters );

        const sorterIndex = sorters.findIndex( s => s.key === columnDefinition.key );

        // toggle existing (ASC -> DESC) sorter without affecting others
        if ( append && sorterIndex !== -1 && sorters[ sorterIndex ].direction === 'ASC' ) {
            sorters[ sorterIndex ] = {
                ...sorters[ sorterIndex ],
                direction: sorters[ sorterIndex ].direction === 'ASC' ? 'DESC' : 'ASC'
            };
        }

        // deleting existing (DESC -> null) sorter without affecting others
        else if ( append && sorterIndex !== -1 ) {
            sorters.splice( sorterIndex, 1 );
        }

        // append new sorter (null -> ASC)
        else if ( append ) {
            sorters.push( {
                key      : columnDefinition.key,
                field    : columnDefinition.field,
                direction: 'ASC'
            } );
        }

        // toggle existing (ASC -> DESC) sorter with unset others
        else if ( sorterIndex !== -1 && sorters[ sorterIndex ].direction === 'ASC' ) {
            sorters = [
                {
                    ...sorters[ sorterIndex ],
                    direction: sorters[ sorterIndex ].direction === 'ASC' ? 'DESC' : 'ASC'
                }
            ];
        }

        // deleting existing (DESC -> null) sorter with unset others
        else if ( sorterIndex !== -1 ) {
            sorters = [];
        }

        // set new sorter (null -> ASC)
        else {
            sorters = [
                {
                    key      : columnDefinition.key,
                    field    : columnDefinition.field,
                    direction: 'ASC'
                }
            ];
        }

        this.props.setParam( uid, 'sorters', sorters );
        if ( search ) {
            this.props.setParam( uid, 'doSearch', true );
        }
    }

    handleHeaderDoubleClick( columnDefinition : ColumnDefinition, headerOnly : boolean = false ) {
        const {
                  uid
              }           = this.props,
              columns     = ( [] as ColumnConfig[] ).concat( this.props.columns ),
              columnIndex = columns.findIndex( c => {
                  return c.key === columnDefinition.key
              } );

        if ( columnIndex !== -1 ) {
            const newColumns = this.applyAutoLayoutToColumns( columns, headerOnly );

            columns[ columnIndex ] = newColumns[ columnIndex ];

            this.props.setParam( uid, 'columns', columns );
        }
    }

    /**
     * Handles forceFit and autoLayout.
     *
     * @return {boolean} True if props are complete and nothing handled, False otherwise
     *
     * @private
     */
    handleForceFitOrAutoLayout( props : AllProps ) : boolean {
        const {
                  actionColumns,
                  forceFit,
                  autoLayout
              } = props as AllProps;

        let retVal                               = false,
            columns : ColumnConfig[] | undefined = props.columns;

        if ( ( forceFit || autoLayout ) && columns === this.props.columns ) {

            // forceFit -> calculate columns widths to show all columns without horizontal scrolling
            if ( forceFit ) {
                columns = this.applyForceFitToColumns( columns, actionColumns );

                // clear forceFit since it will be only applied once
                this.props.setParam( this.props.uid, 'forceFit', false );
            }

            // autoLayout -> calculate column widths to show full column header text
            else if ( autoLayout ) {
                columns = this.applyAutoLayoutToColumns( columns );

                // clear autoLayout since it will be only applied once
                this.props.setParam( this.props.uid, 'autoLayout', false );
            }

            if ( columns !== props.columns ) {
                this.props.setParam( this.props.uid, 'columns', columns );

                retVal = true;
            }
        }

        return retVal;
    }

    updateFullTableWidthAndTableHeaderHeight() {
        setTimeout(
            () => {
                if ( this.dataTable ) {
                    const tableElement       = this.dataTable.getElement(),
                          tableHeaderElement = tableElement?.querySelector( '.p-datatable-thead' ) as HTMLElement,
                          scrollSelector     = tableElement?.getAttribute( 'data-scrollselectors' ) ?? 'nothing',
                          scrollElement      = tableElement?.querySelector( scrollSelector ) as HTMLElement,
                          tableElementWidth  = tableElement?.clientWidth,
                          scrollElementWidth = scrollElement?.clientWidth ?? 0;

                    if ( scrollElement ) {
                        if ( Array.isArray( this.renderedColumns ) ) {
                            let fullTableWidth : string = '100%',
                                autoWidthColumnsCount   = 0,
                                fixedColumnsWidth       = 0;

                            for ( const col of this.renderedColumns as React.ReactElement[] ) {
                                if ( col?.props?.style?.width === 'auto' ) {
                                    autoWidthColumnsCount++;
                                    fixedColumnsWidth += Number( col?.props?.style?.minWidth?.substring( 0, col?.props?.style?.minWidth?.length - 2 ?? 0 ) ?? 150 );
                                }
                                else {
                                    fixedColumnsWidth += Number( col?.props?.style?.width?.substring( 0, col?.props?.style?.width?.length - 2 ?? 0 ) ?? col?.props?.style?.minWidth?.substring( 0, col?.props?.style?.minWidth?.length - 2 ?? 0 ) ?? 0 );
                                }
                            }

                            fullTableWidth = `${fixedColumnsWidth}px`;

                            if ( autoWidthColumnsCount > 0 && scrollElementWidth > fixedColumnsWidth ) {
                                fullTableWidth = '100%';
                            }

                            if ( tableElementWidth && tableElementWidth < fixedColumnsWidth ) {
                                scrollElement.style.setProperty( '--table-width', fullTableWidth );
                            }
                        }

                        if ( tableHeaderElement ) {
                            if ( this.props.filterDisplay === 'row' ) {
                                scrollElement.style.setProperty( '--table-header-height', getComputedStyle( tableHeaderElement ).height );
                            }
                            else {
                                scrollElement.style.setProperty( '--table-header-height', '2.2rem' );
                            }
                        }
                    }
                }
            },
            11
        );
    }

    /**
     * Applies and returns force fit to given columns.
     *
     * @param {ColumnConfig[]} columns
     * @param {ActionColumns} actionColumns
     *
     * @return {ColumnConfig[]}
     *
     * @private
     */
    applyForceFitToColumns( columns : ColumnConfig[], actionColumns : ActionColumns ) : ColumnConfig[] {
        const table                  = document.getElementById( `${this.props.uid}_datatable` ) as HTMLElement,
              nonActionColumnHeaders = document.querySelectorAll( `#${this.props.uid}_datatable .yn-header-column` ) as NodeListOf<HTMLElement>;

        let availableWidth      = table.clientWidth,
            columnsWidth        = 0,
            columnsDereferenced = false;

        // handle action columns
        for ( const actionColumnField in actionColumns ) {
            const actionColumn = actionColumns[ actionColumnField ];

            availableWidth -= actionColumn.width;
        }

        // handle columns
        for ( let i = 0; i < columns.length; i++ ) {
            const column = columns[ i ];

            // decrease availableWidth by fixed width
            if ( column.resizeable === false ) {
                // decrease availableWidth by columns width
                if ( column.width ) {
                    availableWidth -= column.width as number;
                }
                // decrease availableWidth by th width
                else if ( nonActionColumnHeaders[ i ] ) {
                    availableWidth -= nonActionColumnHeaders[ i ].offsetWidth;
                }
            }

            // increase columnsWidth by non fixed widths
            else {
                // increase columnsWidth by column width
                if ( column.width ) {
                    columnsWidth += column.width as number;
                }
                // increase columnsWidth by th width
                else if ( nonActionColumnHeaders[ i ] ) {
                    columnsWidth += nonActionColumnHeaders[ i ].offsetWidth;
                }
            }
        }

        // compute new widths
        for ( let i = 0; i < columns.length; i++ ) {
            // column is not fixed
            if ( columns[ i ].resizeable !== false ) {
                let width;

                // distribute left availableWidth relative to column original widths
                if ( columns[ i ].width ) {
                    width = Math.floor( columns[ i ].width as number * ( availableWidth / columnsWidth ) );
                }
                // distribute left availableWidth relative to th original widths
                else if ( nonActionColumnHeaders[ i ] ) {
                    width = Math.floor( nonActionColumnHeaders[ i ].offsetWidth * ( availableWidth / columnsWidth ) );
                }

                if ( !columns[ i ].width || columns[ i ].width !== width ) {
                    // dereference columns if not
                    if ( !columnsDereferenced ) {
                        columnsDereferenced = true;
                        columns = [].concat( columns as [] );
                    }

                    // dereference column
                    columns[ i ] = Object.assign( {}, columns[ i ] );

                    columns[ i ].width = width;
                }
            }
        }

        return columns;
    }

    /**
     * Applies and returns auto layout to given columns.
     *
     * @param {ColumnConfig[]} columns
     * @param {boolean} headerOnly
     *
     * @return {ColumnConfig[]}
     *
     * @private
     */
    applyAutoLayoutToColumns( columns : ColumnConfig[], headerOnly : boolean = true ) : ColumnConfig[] {
        const {
                  uid
              }                       = this.props,
              columnHeaders           = document.querySelectorAll( `#${uid}_datatable .yn-header-column` ) as NodeListOf<HTMLElement>,
              textWidthMeasureElement = document.createElement( 'div' );

        let columnsDereferenced = false;

        textWidthMeasureElement.id = `${this.props.uid}_textWidthMeasureElement`;
        textWidthMeasureElement.style.position = 'absolute';
        textWidthMeasureElement.style.float = 'left';
        textWidthMeasureElement.style.whiteSpace = 'nowrap';
        textWidthMeasureElement.style.visibility = 'hidden';
        document.body.appendChild( textWidthMeasureElement );

        for ( let i = 0; i < columnHeaders.length; i++ ) {
            if ( columns[ i ] !== undefined && ( columns[ i ].resizeable ?? true ) ) {
                const columnHeaderContent = columnHeaders[ i ].querySelector( '.p-column-header-content' ) as HTMLElement | undefined,
                      columnTitle         = columnHeaders[ i ].querySelector( '.p-column-title' ) as HTMLElement | undefined,
                      columnSorter        = columnHeaders[ i ].querySelector( 'span[data-pc-section=sort]' ) as HTMLElement | undefined,
                      columnSorterBadge   = columnHeaders[ i ].querySelector( '.p-sortable-column-badge' ) as HTMLElement | undefined;

                if ( columnHeaderContent && columnTitle ) {
                    const columnHeaderStyle      = window.getComputedStyle( columnHeaders[ i ] ),
                          columnHeaderOffset     = parseInt( columnHeaderStyle.getPropertyValue( 'padding-left' ) ) + parseInt( columnHeaderStyle.getPropertyValue( 'padding-right' ) ) + parseInt( columnHeaderStyle.getPropertyValue( 'border-left' ) ) + parseInt( columnHeaderStyle.getPropertyValue( 'border-right' ) ),
                          columnSorterStyle      = columnSorter ? window.getComputedStyle( columnSorter ) : undefined,
                          columnSorterWidth      = ( columnSorter?.offsetWidth ?? 0 ) + +( columnSorterStyle ? ( parseInt( columnSorterStyle.getPropertyValue( 'margin-left' ) ) + parseInt( columnSorterStyle.getPropertyValue( 'margin-right' ) ) ) : 0 ),
                          columnSorterBadgeStyle = columnSorterBadge ? window.getComputedStyle( columnSorterBadge ) : undefined,
                          columnSorterBadgeWidth = ( columnSorterBadge?.offsetWidth ?? 0 ) + ( columnSorterBadgeStyle ? ( parseInt( columnSorterBadgeStyle.getPropertyValue( 'margin-left' ) ) + parseInt( columnSorterBadgeStyle.getPropertyValue( 'margin-right' ) ) ) : 0 ),
                          columnTitleStyles      = window.getComputedStyle( columnTitle );

                    textWidthMeasureElement.style.font = columnTitleStyles.font;
                    textWidthMeasureElement.textContent = columnTitle.textContent;

                    const columnTitleWidth     = textWidthMeasureElement.clientWidth,
                          columnHeaderMinWidth = columnTitleWidth + columnHeaderOffset + columnSorterWidth + columnSorterBadgeWidth + 2;

                    let columnWidth = Math.max( ( columns[ i ].width === 'auto' ? 150 : columns[ i ].width ?? 0 ) as number, columnHeaderMinWidth );

                    if ( !headerOnly ) {
                        const bodyRows          = document.querySelectorAll( `#${uid}_datatable .p-datatable-tbody tr` ) as NodeListOf<HTMLElement>,
                              bodyColumnCells   = Array.from( bodyRows ).map( ( row ) => row.querySelectorAll( ':scope td' )?.[ i ] ) as HTMLElement[],
                              footerRows        = document.querySelectorAll( `#${uid}_datatable .p-datatable-tfoot tr` ) as NodeListOf<HTMLElement>,
                              footerColumnCells = Array.from( footerRows ).map( ( row ) => row.querySelectorAll( ':scope td' )?.[ i ] ) as HTMLElement[];

                        for ( let k = 0; k < bodyColumnCells.length; k++ ) {
                            const cellContent = bodyColumnCells[ k ].querySelector( ':scope .yn-cell-renderer-el' ) as HTMLElement | undefined,
                                  cellWidth   = ( cellContent?.scrollWidth ?? 0 ) + ( cellContent?.scrollWidth !== cellContent?.clientWidth ? 2 : 0 );

                            columnWidth = Math.max( columnWidth, bodyColumnCells[ k ].scrollWidth, cellWidth );
                        }

                        for ( let k = 0; k < footerColumnCells.length; k++ ) {
                            columnWidth = Math.max( columnWidth, footerColumnCells[ k ].scrollWidth );
                        }
                    }

                    if ( !columns[ i ].width || columns[ i ].width === 'auto' || columnWidth > ( columns[ i ].width as number ) ) {
                        // dereference columns if not
                        if ( !columnsDereferenced ) {
                            columnsDereferenced = true;
                            columns = [].concat( columns as [] );
                        }

                        // dereference column
                        columns[ i ] = {
                            ...columns[ i ],
                            width: columnWidth
                        };
                    }
                }
            }
        }

        document.body.removeChild( textWidthMeasureElement );

        return columns;
    }

    /**
     * Converts sorters to dataTables multiSortMeta
     *
     * @private
     */
    getMultiSortMeta( sorters : ColumnSorter[] ) : DataTableSortMeta[] {
        const retVal : DataTableSortMeta[] = [];

        sorters.forEach( sorterDefinition => {
            retVal.push( {
                field: sorterDefinition.field,
                order: sorterDefinition.direction === 'ASC'
                    ? 1
                    : -1
            } );
        } );

        return retVal;
    }

    /**
     * Resolves the cellValue for given field and rowData.
     *
     * @param {string} columnField
     * @param {LoadMetaDataRowData} rowData
     * @param {AllProps} [props=this.props]
     * @param {ColumnDefinition} [inColumnDefinition]
     * @param {boolean} [forGetRowValues=false]
     *
     * @return {CellValue | undefined}
     */
    getCellValue( columnField : string, rowData : LoadMetaDataRowData, props : AllProps = this.props, inColumnDefinition? : ColumnDefinition, forGetRowValues : boolean = false ) : CellValue | undefined {
        const {
                  columnDefinitions,
                  dataContext,
                  dataStructure,
                  editable,
                  editMode,
                  editType,
                  elusiveData,
                  rawMode,
                  showAdditionalRawNames,
                  showPropertyDefaults,
                  value: rowDatas
              }                       = props,
              rowIndex                = rowDatas?.findIndex( rD => rD === rowData ) ?? 0,
              changedCellValues       = elusiveData?.changedCellValues ?? {},
              cellEditorValues        = elusiveData?.cellEditorValues ?? {},
              cellEditorInitialValues = elusiveData?.cellEditorInitialValues ?? {},
              cellEditorErrors        = elusiveData?.cellEditorErrors ?? {},
              columnDefinition        = inColumnDefinition ?? columnDefinitions.find( colDef => colDef.field === columnField ),
              dataDescriptor          = columnDefinition?.dataDescriptor,
              cellId                  = DataTable.getCellId( rowIndex, columnField, rowData, dataDescriptor, props );

        let retVal : CellValue | undefined;

        if ( Object.keys( dataStructure ).length && dataDescriptor ) {
            const valueForCell = getValueForDataDescriptorFromRowData(
                dataContext,
                dataDescriptor,
                rowData,
                dataStructure,
                columnField,
                rawMode,
                showAdditionalRawNames,
                showPropertyDefaults
            );

            if ( valueForCell ) {
                const editValue = cellEditorValues[ cellId ] !== undefined ? cellEditorValues[ cellId ] : valueForCell.value;

                retVal = {
                    ...valueForCell,
                    cellId,
                    dataDescriptor,
                    initialValue       : cellEditorInitialValues[ cellId ] ?? undefined,
                    editValue,
                    editorErrorMessages: cellEditorErrors[ cellId ]?.messages,
                    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                    isModified: valueForCell.isModified || valueForCell.value !== editValue
                };

                // STATIC editable columns
                if ( editable && editMode && editType === 'rowData' && dataDescriptor.type === 'static' && columnDefinition?.editor ) {
                    const editorConfig = columnDefinition.editorConfig,
                          initialValue = retVal.value,
                          rowId        = DataTable.getRowId( rowData );

                    if ( !forGetRowValues && editorConfig?.condition ) {
                        retVal.isEditable = resolveConditionRecursive( editorConfig.condition, this.getRowValues( rowData ) );
                    }
                    else {
                        retVal.isEditable = true;
                    }

                    if ( changedCellValues[ rowId ]?.[ columnField ] ) {
                        retVal.value = changedCellValues[ rowId ][ columnField ];
                    }
                    else if ( retVal.value !== undefined && retVal.value !== null ) {
                        retVal.value = String( retVal.value );
                    }
                    if ( retVal.value === undefined ) {
                        retVal.value = null;
                    }

                    if ( cellEditorInitialValues[ cellId ] ) {
                        retVal.initialValue = cellEditorInitialValues[ cellId ];
                    }
                    else if ( initialValue !== undefined && initialValue !== null ) {
                        retVal.initialValue = String( initialValue );
                    }
                    if ( retVal.initialValue === undefined ) {
                        retVal.initialValue = null;
                    }

                    retVal.isModified = retVal.value !== retVal.initialValue;
                    retVal.editValue = cellEditorValues[ cellId ] !== undefined ? cellEditorValues[ cellId ] : retVal.value;

                    if ( retVal.defaultValue !== undefined && retVal.defaultValue !== null ) {
                        retVal.defaultValue = String( retVal.defaultValue );
                    }
                }
            }
        }

        return retVal;
    }

    /**
     * Resolves the rowValues for all columns and given rowData.
     *
     * @param {LoadMetaDataRowData} rowData
     *
     * @return {DataDescriptorValues}
     */
    getRowValues( rowData : LoadMetaDataRowData ) : DataDescriptorValues {
        const retVal : DataDescriptorValues = {},
              {
                  columnDefinitions
              }                             = this.props;

        for ( const columnDefinition of columnDefinitions ) {
            const columnKey   = columnDefinition.key ?? columnDefinition.field.replace( /[.: ()]/g, '_' ),
                  columnField = columnDefinition.field,
                  cellValue   = this.getCellValue( columnField, rowData, undefined, undefined, true );

            if ( cellValue ) {
                retVal[ columnKey ] = cellValue.editValue ?? cellValue.value;

                if ( columnField !== columnKey ) {
                    retVal[ columnField ] = cellValue.editValue ?? cellValue.value;
                }
            }
        }

        return retVal;
    }

    getColumnValues( columnKey : string ) : any[] {
        const retVal : any[] = [],
              {
                  columnDefinitions,
                  elusiveData
              }              = this.props,
              columnField    = columnDefinitions.find( cD => cD.key === columnKey )?.field;

        if ( columnField && elusiveData?.metaData?.rowData ) {
            for ( const rowData of elusiveData.metaData.rowData ) {
                const cellValue = this.getCellValue( columnField, rowData, undefined, undefined, true );

                if ( cellValue ) {
                    retVal.push( cellValue.editValue ?? cellValue.value );
                }
            }
        }

        return retVal;
    }

    getCellMessagePlaceholders( rowData : LoadMetaDataRowData, dataDescriptor : DataDescriptor ) : {
        [ placeholder : string ] : string
    } {
        const retVal : {
                  [ placeholder : string ] : string
              }              = {},
              {
                  columns,
                  valueFieldMapping
              }              = this.props,
              itemLabel      = dataDescriptor.dataObject ? getItemLabelForCypher( dataDescriptor.dataObject ) : '',
              referenceLabel = dataDescriptor.dataObject ? getReferenceLabelForCypher( dataDescriptor.dataObject ) : '';

        for ( const column of columns ) {
            const columnField = column.field;

            if ( column.field.indexOf( itemLabel ) === 0 || column.field.indexOf( referenceLabel ) === 0 ) {
                const cellValue = this.getCellValue( columnField, rowData );

                if ( cellValue ) {
                    const placeholder = ( valueFieldMapping?.[ column.field ] ? valueFieldMapping[ column.field ] : column.field )
                        .replace( `${itemLabel}${aliasSeparator}`, '' )
                        .replace( `${itemLabel}${fieldSeparator}`, '' )
                        .replace( `${referenceLabel}${aliasSeparator}`, '' )
                        .replace( `${referenceLabel}${fieldSeparator}`, '' )
                        .replaceAll( aliasSeparator, fieldSeparator );

                    retVal[ placeholder ] = isPropertyValueType( cellValue.valueType )
                        ? convertValueToString( cellValue.value, cellValue.valueType )
                        : String( cellValue.value );
                }
            }
        }

        return retVal;
    }

    /**
     * Sets the given attributes to items Property given by itemId and propertyTypeId
     *
     * @param {number} itemId
     * @param {number} propertyTypeId
     * @param {PropertyAttributesSettable} attributesToSet
     */
    setPropertyAttributes( itemId : number, propertyTypeId : number, attributesToSet : PropertyAttributesSettable, dispatch? : ScopedDispatch ) {
        const {
                  dataContext
              }                             = this.props,
              propertyTypeIdString          = String( propertyTypeId ),
              data : ItemAttributesSettable = {};

        data.properties = {};
        data.properties[ propertyTypeIdString ] = attributesToSet;

        if ( dispatch ) {
            dispatch( updateItem( dataContext, itemId, data ) );
        }
        else {
            this.props.updateItem( dataContext, itemId, data );
        }
    }

    /**
     * Sets the given attributes to items EnumProperty given by itemId, propertyTypeId and key
     *
     * @param {number} itemId
     * @param {number} propertyTypeId
     * @param {string} key
     * @param attributesToSet
     */
    setEnumPropertyAttributes( itemId : number, propertyTypeId : number, key : string, attributesToSet : PropertyAttributesSettable, dispatch? : ScopedDispatch ) {
        const {
                  dataContext
              }                             = this.props,
              propertyTypeIdString          = String( propertyTypeId ),
              data : ItemAttributesSettable = {};

        data.enumProperties = {};
        data.enumProperties[ propertyTypeIdString ] = {
            properties: {}
        };
        data.enumProperties[ propertyTypeIdString ].properties![ key ] = attributesToSet;

        if ( dispatch ) {
            dispatch( updateItem( dataContext, itemId, data ) );
        }
        else {
            this.props.updateItem( dataContext, itemId, data );
        }
    }

    /**
     * Sets the given attributes to references Property given by referenceId and propertyTypeId
     *
     * @param {number} referenceId
     * @param {number} propertyTypeId
     * @param {ReferencePropertyAttributesSettable} attributesToSet
     */
    setReferencePropertyAttributes( referenceId : number, propertyTypeId : number, attributesToSet : ReferencePropertyAttributesSettable, dispatch? : ScopedDispatch ) {
        const {
                  dataContext
              }                                  = this.props,
              propertyTypeIdString               = String( propertyTypeId ),
              data : ReferenceAttributesSettable = {};

        data.properties = {};
        data.properties[ propertyTypeIdString ] = attributesToSet;

        if ( dispatch ) {
            dispatch( updateReference( dataContext, referenceId, data ) );
        }
        else {
            this.props.updateReference( dataContext, referenceId, data );
        }
    }

    /**
     * Sets the given attributes to references Property given by referenceId, propertyTypeId and key
     *
     * @param {number} referenceId
     * @param {number} propertyTypeId
     * @param {string} key
     * @param {ReferencePropertyAttributesSettable} attributesToSet
     */
    setEnumReferencePropertyAttributes( referenceId : number, propertyTypeId : number, key : string, attributesToSet : ReferencePropertyAttributesSettable, dispatch? : ScopedDispatch ) {
        const {
                  dataContext
              }                                  = this.props,
              propertyTypeIdString               = String( propertyTypeId ),
              data : ReferenceAttributesSettable = {};

        data.enumProperties = {};
        data.enumProperties[ propertyTypeIdString ] = {
            properties: {}
        };
        data.enumProperties[ propertyTypeIdString ].properties![ key ] = attributesToSet;

        if ( dispatch ) {
            dispatch( updateReference( dataContext, referenceId, data ) );
        }
        else {
            this.props.updateReference( dataContext, referenceId, data );
        }
    }

    /**
     * Builds the editor for column.
     *
     * @private
     */
    getEditor( columnEditorProps : ColumnEditorProps, columnProps : ColumnEditorOptions ) : React.ReactNode {
        const {
                  schema,
                  timezone,
                  dataStructure,
                  rawMode,
                  showAdditionalRawNames,
                  user
              }                                           = this.props,
              {
                  dataDescriptor,
                  editorConfig,
                  field,
                  helpText,
                  style,
                  valueType
              }                                           = columnEditorProps,
              rowData                                     = this.dataTableValue[ columnProps.rowIndex ].rowData,
              cellValue                                   = this.getCellValue( field, rowData ),
              table                                       = document.getElementById( columnProps.props.id ),
              rows                                        = table ? table.querySelectorAll( 'tbody > tr' ) : [],
              row                                         = rows[ columnProps.rowIndex ],
              height                                      = Math.max( row?.clientHeight ?? 0, 120 ),
              editorParams                                = {
                  id               : '',
                  key              : 'cellEditor',
                  appendToElementId: 'document',
                  autoComplete     : false,
                  autoFocus        : true,
                  classNames       : [ 'yn-cell-editor' ],
                  infoTextLayout   : 'hidden',
                  inputStyle       : {
                      textAlign: style?.textAlign ?? 'left'
                  },
                  labelWidth       : 0,
                  // input keeps the typed value locally and debounces the upward onChange
                  // -> no DataTable re-render per keystroke; flush happens on blur (commit)
                  useHookForm: true,
                  onResize   : this.onCellEditorResize.bind( this, field )
              },
              tooltipContent : ( string | JSX.Element )[] = [];

        let retVal : string | JSX.Element | ( string | JSX.Element )[] | undefined;

        if ( cellValue?.isEditable ) {
            let editValue = cellValue.editValue ?? cellValue.initialValue;

            editorParams.id = `cellEditor_${cellValue.cellId}_${columnProps.rowIndex}`;

            // helpText
            if ( helpText ) {
                // TODO: message resolver for row item and so on
                tooltipContent.push(
                    <div key="help" className="yn-tooltip-help">
                        <div className="yn-tooltip-header">
                            {__( 'YN.base.frontend.dataTable.tooltip.helpText.title' )}
                        </div>
                        {__( helpText )}
                    </div>
                );
            }

            // error
            if ( cellValue.editorErrorMessages?.length ) {
                editorParams.classNames.push( 'yn-error-border' );

                tooltipContent.push(
                    <div key="error" className="yn-tooltip-error">
                        <div className="yn-tooltip-header">
                            {__( 'YN.base.common.tooltip.error.title' )}
                        </div>
                        {cellValue.editorErrorMessages.map( message => <>{message}<br/></> )}
                    </div>
                );
            }

            // get ValueSet editor
            if ( cellValue.valueSetId ) {
                let type : 'property' | 'referenceProperty' = 'property',
                    setId : number                          = 0;

                if ( dataDescriptor.type === 'property' && dataDescriptor.dataObject.item.objectType ) {
                    const propertySet = metaModel[ schema ].getPropertySetForItemTypeAndPropertyType( dataDescriptor.dataObject.item.objectType, dataDescriptor.propertyTypeName );

                    if ( propertySet ) {
                        setId = propertySet.id;
                    }
                }
                else if ( dataDescriptor.type === 'referenceProperty' ) {
                    const dataObject = getDataObject( dataDescriptor.dataObject.id, dataStructure );

                    type = 'referenceProperty';

                    if ( dataObject ) {
                        const referenceSets = getReferenceSetsForDataObject( dataDescriptor.dataObject, dataStructure, schema );

                        if ( referenceSets.length === 1 ) {
                            const referencePropertySet = metaModel[ schema ].getReferencePropertySetForReferenceSetAndPropertyType( referenceSets[ 0 ].id, dataDescriptor.propertyTypeName );

                            if ( referencePropertySet ) {
                                setId = referencePropertySet.id;
                            }
                        }
                    }
                }

                retVal = getValueSetEditor( schema, type, setId, editValue, this.onEditorChange.bind( this, columnEditorProps, columnProps, rowData ), rawMode, showAdditionalRawNames, editorParams );
            }
            else if ( dataDescriptor.type === 'static' && editorConfig?.valueSetId ) {
                retVal = getValueSetEditor( editorConfig.schema ?? schema, 'static', editorConfig.valueSetId, editValue, this.onEditorChange.bind( this, columnEditorProps, columnProps, rowData ), rawMode, showAdditionalRawNames, editorParams );
            }

            // get ValueType editor
            else {
                if ( !editValue && ( valueType === 'DATE' || valueType === 'TIME' || valueType === 'TIMESTAMP' ) ) {
                    editValue = new Date();
                }

                const params = {
                    schema,
                    timezone,
                    showAdditionalRawNames,
                    valueUnit : cellValue.valueUnit,
                    valuePrecision,
                    language  : user?.language,
                    returnMode: 'id',
                    height
                };

                retVal = getValueEditor( valueType, editValue, this.onEditorChange.bind( this, columnEditorProps, columnProps, rowData ), rawMode, params, editorParams );
            }

            if ( retVal && !Array.isArray( retVal ) ) {
                retVal = [ retVal ];
            }

            if ( retVal && tooltipContent.length ) {
                retVal.push(
                    <Tooltip
                        key="editorTooltip"
                        target={`#${editorParams.id}`}
                        event="focus"
                        my="left top"
                        at="left bottom"
                        className="yn-tooltip"
                        showDelay={250}
                    >
                        {tooltipContent}
                    </Tooltip>
                );
            }
        }

        // return body renderer result to avoid flickering
        if ( !retVal ) {
            retVal = rowData[ field ];
        }

        return retVal;
    }

    /**
     * Returns the cached filter for column.
     *
     * @param columnProps
     */
    getFilter( columnProps : ColumnFilterElementTemplateOptions ) : React.ReactNode {
        return this.renderedFilters?.[ columnProps.field ] ?? undefined;
    }

    getColumnFooter( key : string, footer : string, columnOptions : ColumnFooterOptions ) : React.ReactNode {
        const {
                  columnDefinitions,
                  schema,
                  timezone,
                  rawMode,
                  showAdditionalRawNames,
                  user
              }                                                            = this.props,
              allowedComputedPlaceholders                                  = [
                  'columnCount',
                  'columnCountDistinct',
                  'columnCountNonEmpty',
                  'columnSum',
                  'columnAvg',
                  'columnMin',
                  'columnMax'
              ],
              usedComputedPlaceholders : string[]                          = [],
              computedPlaceholders : { [ placeholder : string ] : string } = {};

        let retVal : React.ReactNode = undefined;

        footer = __( footer );

        for ( const placeholder of allowedComputedPlaceholders ) {
            if ( footer.indexOf( `\${${placeholder}}` ) !== -1 ) {
                usedComputedPlaceholders.push( placeholder );
            }
        }

        if ( usedComputedPlaceholders.length ) {
            const columnDefinition = columnDefinitions.find( colDef => colDef.key === key );

            if ( columnDefinition ) {
                const columnValues                = this.getColumnValues( key ),
                      cellValue                   = this.getCellValue( columnDefinition.field, {} ),
                      renderValueParams : any     = {
                          schema,
                          timezone,
                          language : user?.language,
                          showAdditionalRawNames,
                          valueUnit: cellValue?.valueUnit,
                          valuePrecision
                      },
                      valueType : FilterValueType = cellValue?.valueType ?? 'STRING',
                      valueTypeIsNumeric          = valueType === 'CURRENCY' || valueType === 'DOUBLE' || valueType === 'DURATION' || valueType === 'INTEGER';


                for ( const placeholder of usedComputedPlaceholders ) {
                    let replacement : string   = placeholder,
                        nonEmptyValues : any[] = [];

                    if (
                        placeholder === 'columnCountNonEmpty'
                        || placeholder === 'columnSum'
                        || placeholder === 'columnAvg'
                        || placeholder === 'columnMin'
                        || placeholder === 'columnMax'
                    ) {
                        nonEmptyValues = columnValues.reduce(
                            ( innerRetVal, columnValue ) => {
                                if ( columnValue !== undefined && columnValue !== null && columnValue !== '' ) {
                                    innerRetVal.push( columnValue );
                                }

                                return innerRetVal;
                            },
                            [] as any[]
                        );
                    }

                    switch ( placeholder ) {
                        case 'columnCount':
                            replacement = String( columnValues.length );
                            break;

                        case 'columnCountDistinct':
                            replacement = String( columnValues.reduce(
                                ( innerRetVal, columnValue ) => {
                                    if ( !innerRetVal.includes( columnValue ) ) {
                                        innerRetVal.push( columnValue );
                                    }

                                    return innerRetVal;
                                },
                                [] as any[]
                            ).length );
                            break;

                        case 'columnCountNonEmpty':
                            replacement = String( nonEmptyValues.length );
                            break;

                        case 'columnSum':
                            if ( valueTypeIsNumeric ) {
                                replacement = renderToString( <>{renderValue(
                                    valueType,
                                    nonEmptyValues.reduce(
                                        ( innerRetVal, columnValue ) => {
                                            innerRetVal += parseFloat( columnValue );

                                            return innerRetVal;
                                        },
                                        0
                                    ),
                                    renderValueParams,
                                    rawMode
                                )}</> );
                            }
                            else {
                                replacement = 'n/a';
                            }
                            break;

                        case 'columnAvg':
                            if ( valueTypeIsNumeric ) {
                                if ( nonEmptyValues.length ) {
                                    replacement = renderToString( <>{renderValue(
                                        valueType,
                                        nonEmptyValues.reduce(
                                            ( innerRetVal, columnValue ) => {
                                                innerRetVal += parseFloat( columnValue );

                                                return innerRetVal;
                                            },
                                            0
                                        ) / nonEmptyValues.length,
                                        renderValueParams,
                                        rawMode
                                    )}</> );
                                }
                                else {
                                    replacement = '0';
                                }
                            }
                            else {
                                replacement = 'n/a';
                            }
                            break;

                        case 'columnMin':
                            if ( valueTypeIsNumeric ) {
                                if ( nonEmptyValues.length ) {
                                    replacement = renderToString( <>{renderValue(
                                        valueType,
                                        nonEmptyValues.reduce(
                                            ( innerRetVal, columnValue ) => {
                                                if ( innerRetVal === undefined ) {
                                                    innerRetVal = parseFloat( columnValue );
                                                }
                                                else {
                                                    innerRetVal = Math.min( innerRetVal, parseFloat( columnValue ) );
                                                }

                                                return innerRetVal;
                                            },
                                            undefined
                                        ),
                                        renderValueParams,
                                        rawMode
                                    )}</> );
                                }
                                else {
                                    replacement = '0';
                                }
                            }
                            else {
                                replacement = 'n/a';
                            }
                            break;

                        case 'columnMax':
                            if ( valueTypeIsNumeric ) {
                                if ( nonEmptyValues.length ) {
                                    replacement = renderToString( <>{renderValue(
                                        valueType,
                                        nonEmptyValues.reduce(
                                            ( innerRetVal, columnValue ) => {
                                                if ( innerRetVal === undefined ) {
                                                    innerRetVal = parseFloat( columnValue );
                                                }
                                                else {
                                                    innerRetVal = Math.max( innerRetVal, parseFloat( columnValue ) );
                                                }

                                                return innerRetVal;
                                            },
                                            undefined
                                        ),
                                        renderValueParams,
                                        rawMode
                                    )}</> );
                                }
                                else {
                                    replacement = '0';
                                }
                            }
                            else {
                                replacement = 'n/a';
                            }
                            break;
                    }

                    computedPlaceholders[ placeholder ] = replacement;
                }

                footer = __( footer, computedPlaceholders );
            }
        }

        if ( !isInvalidHTML( footer ) ) {
            retVal = parse( footer );
        }
        else if ( footer ) {
            retVal = footer;
        }

        return retVal;
    }

    setCellValue( valueToSet : any, columnField : string, rowData : LoadMetaDataRowData, batchCtx : BatchContext ) : boolean | 'change' | 'revert' {
        const {
                  dataContext,
                  schema,
                  editMode,
                  dataStructure,
                  columnDefinitions,
                  value
              }                     = this.props,
              {
                  dispatch,
                  cellEditorValues,
                  cellEditorErrors,
                  changedCellValues
              }                     = batchCtx,
              columnDefinition      = columnDefinitions.find( colDef => colDef.field === columnField ) as ColumnDefinition | undefined,
              rowIndex              = value?.findIndex( rD => rD === rowData ) ?? 0,
              attributesToSet : any = {};

        let retVal : boolean | 'change' | 'revert' = false;

        if ( !columnDefinition ) {
            return retVal;
        }

        const {
                  dataDescriptor,
                  permissions
              }      = columnDefinition,
              field  = columnField,
              cellId = DataTable.getCellId( rowIndex, field, rowData, dataDescriptor, this.props );

        // stash the value so it survives until either success (deleted below) or error (kept for retry)
        cellEditorValues[ cellId ] = valueToSet;

        // editMode and editable?
        if ( editMode && valueToSet !== undefined && Object.keys( dataStructure ).length && dataDescriptor && permissions ) {
            const additionalCheckParameters : any = {};

            if ( dataDescriptor.type === 'reference' ) {
                const reference = getReferenceForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                additionalCheckParameters.referenceSetId = reference?.referenceSetId;
            }

            if ( dataDescriptor.attribute && isColumnEditable( dataDescriptor, dataStructure, schema, permissions, additionalCheckParameters ) ) {
                let editObject : Item | Property | Reference | ReferenceProperty | undefined,
                    columnFieldToValidate : string                      = '',
                    errors : ( string | JSX.Element | JSX.Element[] )[] = [];

                attributesToSet[ dataDescriptor.attribute ] = valueToSet;

                try {
                    switch ( dataDescriptor.type ) {
                        case 'item':
                            editObject = getItemForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                            if ( editObject ) {
                                if ( dispatch ) {
                                    dispatch( updateItem( dataContext, editObject.id, attributesToSet ) );
                                }
                                else {
                                    this.props.updateItem( dataContext, editObject.id, attributesToSet );
                                }
                            }

                            break;

                        case 'property':
                            editObject = getPropertyForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                            if ( editObject ) {
                                // revert deletion after edit
                                if ( editObject.isAttributeModified( 'statusId' ) && editObject.statusId === deletedStatusId[ schema ] ) {
                                    attributesToSet.statusId = editObject.attributesModified.get( 'statusId' );
                                }

                                if ( editObject.propertySet.isEnumerated ) {
                                    this.setEnumPropertyAttributes( editObject.itemId, editObject.propertySet.propertyTypeId, editObject.stringKey, attributesToSet, dispatch );
                                }
                                else {
                                    this.setPropertyAttributes( editObject.itemId, editObject.propertySet.propertyTypeId, attributesToSet, dispatch );
                                }
                            }
                            else {
                                const propertySet = dataDescriptor.dataObject.item.objectType
                                    ? metaModel[ schema ].getPropertySetForItemTypeAndPropertyType( dataDescriptor.dataObject.item.objectType, dataDescriptor.propertyTypeName )
                                    : undefined;

                                editObject = getItemForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                                if ( editObject && propertySet ) {
                                    if ( propertySet.isEnumerated ) {
                                        attributesToSet.key = attributesToSet.key || 'key';
                                        attributesToSet.value = attributesToSet.value || getDefaultValueForType( propertySet.valueType );

                                        this.setEnumPropertyAttributes( editObject.id, propertySet.propertyTypeId, '', attributesToSet, dispatch );

                                        if ( dataDescriptor.attribute === 'key' ) {
                                            columnFieldToValidate = columnDefinitions.find( cD => cD.dataDescriptor.dataObject?.origId === dataDescriptor.dataObject.origId && cD.dataDescriptor.type === 'property' && cD.dataDescriptor.propertyTypeName === dataDescriptor.propertyTypeName && cD.dataDescriptor.attribute === 'value' )?.field ?? '';

                                            if ( columnFieldToValidate ) {
                                                errors = this.validateValueForCell( attributesToSet.value, columnFieldToValidate, rowData );
                                            }
                                        }
                                        else {
                                            columnFieldToValidate = columnDefinitions.find( cD => cD.dataDescriptor.dataObject?.origId === dataDescriptor.dataObject.origId && cD.dataDescriptor.type === 'property' && cD.dataDescriptor.propertyTypeName === dataDescriptor.propertyTypeName && cD.dataDescriptor.attribute === 'key' )?.field ?? '';

                                            if ( columnFieldToValidate ) {
                                                errors = this.validateValueForCell( attributesToSet.key, columnFieldToValidate, rowData );
                                            }
                                        }
                                    }
                                    else {
                                        this.setPropertyAttributes( editObject.id, propertySet.propertyTypeId, attributesToSet, dispatch );
                                    }
                                }
                            }

                            break;

                        case 'reference':
                            editObject = getReferenceForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                            if ( editObject ) {
                                if ( dispatch ) {
                                    dispatch( updateReference( dataContext, editObject.id, attributesToSet ) );
                                }
                                else {
                                    this.props.updateReference( dataContext, editObject.id, attributesToSet );
                                }
                            }

                            break;

                        case 'referenceProperty':
                            editObject = getReferencePropertyForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                            if ( editObject ) {

                                // revert deletion after edit
                                if ( editObject.isAttributeModified( 'statusId' ) && editObject.statusId === deletedStatusId[ schema ] ) {
                                    attributesToSet.statusId = editObject.attributesModified.get( 'statusId' );
                                }

                                if ( editObject.referencePropertySet.isEnumerated ) {
                                    this.setEnumReferencePropertyAttributes( editObject.referenceId, editObject.referencePropertySet.propertyTypeId, editObject.stringKey, attributesToSet, dispatch );
                                }
                                else {
                                    this.setReferencePropertyAttributes( editObject.referenceId, editObject.referencePropertySet.propertyTypeId, attributesToSet, dispatch );
                                }
                            }
                            else {
                                editObject = getReferenceForDataDescriptorFromRowData( dataContext, dataDescriptor, dataStructure );

                                const referencePropertySet = editObject
                                    ? metaModel[ schema ].getReferencePropertySetForReferenceSetAndPropertyType( editObject.referenceSetId, dataDescriptor.propertyTypeName )
                                    : undefined;

                                if ( editObject && referencePropertySet ) {
                                    if ( referencePropertySet.isEnumerated ) {
                                        attributesToSet.key = attributesToSet.key || 'key';
                                        attributesToSet.value = attributesToSet.value || getDefaultValueForType( referencePropertySet.valueType );

                                        this.setEnumReferencePropertyAttributes( editObject.id, referencePropertySet.propertyTypeId, '', attributesToSet, dispatch );
                                        if ( dataDescriptor.attribute === 'key' ) {
                                            columnFieldToValidate = columnDefinitions.find( cD => cD.dataDescriptor.dataObject?.origId === dataDescriptor.dataObject.origId && cD.dataDescriptor.type === 'referenceProperty' && cD.dataDescriptor.propertyTypeName === dataDescriptor.propertyTypeName && cD.dataDescriptor.attribute === 'value' )?.field ?? '';

                                            if ( columnFieldToValidate ) {
                                                errors = this.validateValueForCell( attributesToSet.value, columnFieldToValidate, rowData );
                                            }
                                        }
                                        else {
                                            columnFieldToValidate = columnDefinitions.find( cD => cD.dataDescriptor.dataObject?.origId === dataDescriptor.dataObject.origId && cD.dataDescriptor.type === 'referenceProperty' && cD.dataDescriptor.propertyTypeName === dataDescriptor.propertyTypeName && cD.dataDescriptor.attribute === 'key' )?.field ?? '';

                                            if ( columnFieldToValidate ) {
                                                errors = this.validateValueForCell( attributesToSet.key, columnFieldToValidate, rowData );
                                            }
                                        }
                                    }
                                    else {
                                        this.setReferencePropertyAttributes( editObject.id, referencePropertySet.propertyTypeId, attributesToSet, dispatch );
                                    }
                                }
                            }

                            break;
                    }
                }
                catch ( e ) {
                    if ( e instanceof Error || typeof e === 'string' ) {
                        errors = [ String( e ) ];
                    }
                }

                if ( errors.length ) {
                    if ( columnFieldToValidate ) {
                        cellEditorErrors[ DataTable.getCellId( rowIndex, columnFieldToValidate, rowData, dataDescriptor, this.props ) ] = {
                            field   : columnFieldToValidate,
                            rowIndex,
                            messages: errors
                        };
                    }
                    else {
                        cellEditorErrors[ cellId ] = {
                            field,
                            rowIndex,
                            messages: errors
                        };
                    }
                }
                else {
                    delete cellEditorValues[ cellId ];
                    retVal = true;
                }
            }
            else if ( dataDescriptor.type === 'static' && isColumnEditable( dataDescriptor, dataStructure, schema, permissions, additionalCheckParameters ) ) {
                const cellValue = this.getCellValue( field, rowData ),
                      rowId     = DataTable.getRowId( rowData );

                if ( valueToSet !== cellValue?.initialValue ) {
                    changedCellValues[ rowId ] = {
                        ...changedCellValues[ rowId ],
                        [ field ]: valueToSet
                    };

                    retVal = 'change';
                }
                else {
                    if ( changedCellValues[ rowId ] ) {
                        delete changedCellValues[ rowId ][ field ];

                        if ( !Object.keys( changedCellValues[ rowId ] ).length ) {
                            delete changedCellValues[ rowId ];
                        }
                    }

                    retVal = 'revert';
                }

                delete cellEditorValues[ cellId ];
            }
        }

        return retVal;
    }

    validateValueForCell( valueToValidate : any, columnField : string, rowData : LoadMetaDataRowData ) : ( string | JSX.Element | JSX.Element[] )[] {
        const retVal : ( string | JSX.Element | JSX.Element[] )[] = [],
              {
                  dataContext,
                  columnDefinitions,
                  value
              }                                                   = this.props,
              columnDefinition                                    = columnDefinitions.find( colDef => colDef.field === columnField ) as ColumnDefinition,
              {
                  dataDescriptor,
                  editorValidatorRegExp    : validatorRegExp,
                  editorValidationErrorText: validationErrorText
              }                                                   = columnDefinition,
              rowIndex                                            = value?.findIndex( rD => rD === rowData ) ?? 0, // stringify compare?
              cellId                                              = DataTable.getCellId( rowIndex, columnField, rowData, dataDescriptor, this.props );

        // validation
        if ( dataDescriptor ) {
            // item checks
            if ( dataDescriptor.type === 'item' ) {

                // key checks
                if ( dataDescriptor.attribute === 'key' ) {

                    // empty check
                    if ( !valueToValidate ) {
                        retVal.push( __( 'YN.base.frontend.dataTable.item.key.error.empty' ) );
                    }

                    // whitespaces check
                    else if ( / /.test( valueToValidate ) ) {
                        retVal.push( __( 'YN.base.frontend.dataTable.item.key.error.whiteSpaces' ) );
                    }

                    // uniqueness check
                    else {
                        const item = getItemForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        if ( item ) {
                            if ( this.checkKeyUniqueness( item, valueToValidate, cellId, columnField, rowIndex ) ) {
                                retVal.push( __( 'YN.base.frontend.dataTable.item.key.check.unique' ) );
                            }
                        }
                    }
                }

                // name check
                else if ( dataDescriptor.attribute === 'name' ) {

                    // empty check
                    if ( !valueToValidate.trim() ) {
                        retVal.push( __( 'YN.base.frontend.dataTable.item.name.error.empty' ) );
                    }
                }
            }

            // property checks
            else if ( dataDescriptor.type === 'property' ) {

                // key checks
                if ( dataDescriptor.attribute === 'key' ) {

                    // empty check
                    if ( !valueToValidate ) {
                        retVal.push( __( 'YN.base.frontend.dataTable.property.enumProperty.key.error.empty' ) );
                    }

                    // whitespaces check
                    else if ( / /.test( valueToValidate ) ) {
                        retVal.push( __( 'YN.base.frontend.dataTable.property.enumProperty.key.error.whiteSpaces' ) );
                    }

                    // uniqueness check
                    else {
                        const property = getPropertyForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        if ( property?.parent instanceof EnumProperty ) {
                            property.parent.properties.forEach( rawProperty => {
                                if ( valueToValidate === rawProperty.key && property !== rawProperty ) {
                                    retVal.push( __( 'YN.base.frontend.dataTable.enumProperty.key.error.notUnique' ) );
                                }
                            } );
                        }
                    }
                }

                // value checks
                else if ( dataDescriptor.attribute === 'value' ) {

                    // empty check
                    if ( !String( valueToValidate ).trim() ) {
                        retVal.push( __( 'YN.base.frontend.dataTable.property.value.error.empty' ) );
                    }

                    else {
                        const property = getPropertyForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        if ( property ) {
                            try {
                                validateValueForType( valueToValidate, property.propertySet.valueType, true );
                            }
                            catch ( e ) {
                                if ( e instanceof Error ) {
                                    retVal.push( e.toString() );
                                }
                                else {
                                    retVal.push( String( e ) );
                                }
                            }
                        }
                    }
                }
            }

            // referenceProperty checks
            else if ( dataDescriptor.type === 'referenceProperty' ) {

                // key checks
                if ( dataDescriptor.attribute === 'key' ) {

                    // empty check
                    if ( !valueToValidate ) {
                        retVal.push( __( 'YN.base.frontend.dataTable.enumProperty.key.error.empty' ) );
                    }

                    // whitespaces check
                    else if ( / /.test( valueToValidate ) ) {
                        retVal.push( __( 'YN.base.frontend.dataTable.enumProperty.key.error.whiteSpaces' ) );
                    }

                    // uniqueness check
                    else {
                        const referenceProperty = getReferencePropertyForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        if ( referenceProperty?.parent instanceof EnumReferenceProperty ) {
                            referenceProperty.parent.properties.forEach( rawReferenceProperty => {
                                if ( valueToValidate === rawReferenceProperty.key && referenceProperty !== rawReferenceProperty ) {
                                    retVal.push( __( 'YN.base.frontend.dataTable.enumProperty.key.error.notUnique' ) );
                                }
                            } );
                        }
                    }
                }

                // value checks
                else if ( dataDescriptor.attribute === 'value' ) {

                    // empty check
                    if ( !String( valueToValidate ).trim() ) {
                        retVal.push( __( 'YN.base.frontend.dataTable.property.editValue.error.empty' ) );
                    }

                    // JSON parse check
                    else {
                        const referenceProperty = getReferencePropertyForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        if ( referenceProperty ) {
                            try {
                                validateValueForType( valueToValidate, referenceProperty.referencePropertySet.valueType, true );
                            }
                            catch ( e ) {
                                if ( e instanceof Error ) {
                                    retVal.push( e.toString() );
                                }
                                else {
                                    retVal.push( String( e ) );
                                }
                            }
                        }
                    }
                }
            }

            // custom
            if ( validatorRegExp ) {
                if ( !String( valueToValidate ).match( `${validatorRegExp}` ) ) {
                    if ( validationErrorText ) {
                        retVal.push( __( validationErrorText ) );
                    }
                    else {
                        retVal.push( __( 'YN.base.frontend.dataTable.validatorRegExp.error', { regExp: validatorRegExp } ) );
                    }
                }
            }
        }

        if ( retVal.length ) {
            for ( let i = 0; i < retVal.length; i++ ) {
                retVal[ i ] = parse( String( retVal[ i ] ) );
            }
        }

        return retVal;
    }

    /**
     * Builds the contextMenu content for current selected cell.
     */
    getContextMenuModel( contextMenuCellInfo : State['contextMenuCellInfo'] ) : MenuItem[] {
        const retVal : MenuItem[] = [],
              {
                  columnDefinitions,
                  dataContext,
                  dataStructure,
                  elusiveData,
                  filters,
                  schema
              }                   = this.props;

        if ( contextMenuCellInfo ) {
            const columnKey                   = contextMenuCellInfo.columnKey,
                  columnField                 = contextMenuCellInfo.columnField,
                  rowData                     = contextMenuCellInfo.rowData.rowData,
                  cellValue                   = this.getCellValue( columnField, rowData ),
                  rowRootItemIdDataDescriptor = buildDataDescriptor( { attributePath: 'item.id' }, dataStructure ) as ItemDataDescriptor,
                  rowRootItemId               = rowData[ rowRootItemIdDataDescriptor?.alias ],
                  rowRootItem                 = global.data[ dataContext ]?.items[ rowRootItemId ];

            if ( cellValue && !cellValue.dataDescriptor.aggregate ) {
                const dataDescriptor = cellValue.dataDescriptor;

                // edit options (revert / delete)
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                if ( this.props.editMode && ( cellValue.isEditable || ( cellValue.isModified && cellValue.isDeleted ) ) ) {

                    // revert
                    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                    if ( cellValue.isNew || cellValue.isModified || cellValue.isDeleted ) {
                        retVal.push(
                            {
                                label  : __( 'YN.base.frontend.dataTable.contextMenu.revert' ),
                                icon   : 'pi pi-fw pi-undo',
                                command: ( event ) => {
                                    this.revertCellContent( columnField, rowData, event.originalEvent );
                                }
                            }
                        );
                    }

                    // delete (only for props)
                    if ( !cellValue.isNew && !cellValue.isDeleted && !cellValue.isDefault && ( dataDescriptor.type === 'property' || dataDescriptor.type === 'referenceProperty' ) ) {
                        retVal.push(
                            {
                                label  : __( 'YN.base.frontend.dataTable.contextMenu.delete' ),
                                icon   : 'pi pi-fw pi-minus-circle yn-red',
                                command: () => {
                                    this.deleteCellContent( columnField, rowData );
                                }
                            }
                        );
                    }
                }

                // delete all loaded cells in column
                // use for all loaded cells in column
                // revert all values of loaded cells in column
                if ( this.props.editMode && ( !!cellValue.isEditable || !!cellValue.isModified || !!cellValue.isDeleted ) ) {
                    if ( retVal.length ) {
                        retVal.push( { separator: true } );
                    }

                    // use for all loaded cells in column
                    if ( cellValue.statusId && !cellValue.isDeleted && !cellValue.editorErrorMessages?.length ) {
                        retVal.push( {
                            label  : __( 'YN.base.frontend.dataTable.contextMenu.setToAllLoadedCellsInColumn' ),
                            icon   : getIconSpan( 'p-menuitem-icon yn-icon material-symbols-outlined yn-blue ::table_edit::' ),
                            command: ( event : MenuItemCommandEvent ) => {
                                this.props.dispatchBatched( ( dispatch ) => {
                                    const batchCtx : BatchContext = {
                                        dispatch,
                                        cellEditorValues : {},
                                        cellEditorErrors : {},
                                        changedCellValues: {}
                                    };

                                    for ( let rowIndex = 0; rowIndex < this.dataTableValue.length; rowIndex++ ) {
                                        const setCellValueResult = this.setCellValue(
                                            cellValue.value,
                                            columnField,
                                            this.dataTableValue[ rowIndex ].rowData,
                                            batchCtx
                                        );

                                        if ( setCellValueResult === 'change' ) {
                                            void this.props.onRowDataChange?.( columnField, cellValue.value, { ...rowData }, event.originalEvent, batchCtx.changedCellValues );
                                        }
                                        else if ( setCellValueResult === 'revert' ) {
                                            void this.props.onRowDataRevert?.( columnField, { ...rowData }, event.originalEvent, batchCtx.changedCellValues );
                                        }
                                    }
                                } );
                            }
                        } );
                    }

                    // delete all loaded cells in column
                    retVal.push( {
                        label  : __( 'YN.base.frontend.dataTable.contextMenu.deleteAllLoadedCellsInColumn' ),
                        icon   : 'pi pi-minus-circle yn-red',
                        command: ( _event : MenuItemCommandEvent ) => {
                            this.props.dispatchBatched( ( dispatch ) => {
                                const batchCtx : BatchContext = {
                                    dispatch,
                                    cellEditorValues : { ...elusiveData?.cellEditorValues ?? {} },
                                    cellEditorErrors : { ...elusiveData?.cellEditorErrors ?? {} },
                                    changedCellValues: { ...elusiveData?.changedCellValues ?? {} }
                                };

                                for ( let rowIndex = 0; rowIndex < this.dataTableValue.length; rowIndex++ ) {
                                    this.deleteCellContent( columnField, this.dataTableValue[ rowIndex ].rowData, batchCtx );
                                }

                                dispatch( setElusiveData( this.props.uid, {
                                    cellEditorValues: batchCtx.cellEditorValues,
                                    cellEditorErrors: batchCtx.cellEditorErrors
                                } ) );
                            } );
                        }
                    } );

                    // revert all values of loaded cells in column
                    retVal.push( {
                        label  : __( 'YN.base.frontend.dataTable.contextMenu.revertAllLoadedCellsInColumn' ),
                        icon   : 'pi pi-undo',
                        command: ( event : MenuItemCommandEvent ) => {
                            this.props.dispatchBatched( ( dispatch ) => {
                                const batchCtx : BatchContext = {
                                    dispatch,
                                    cellEditorValues : { ...elusiveData?.cellEditorValues ?? {} },
                                    cellEditorErrors : { ...elusiveData?.cellEditorErrors ?? {} },
                                    changedCellValues: { ...elusiveData?.changedCellValues ?? {} }
                                };

                                for ( let rowIndex = 0; rowIndex < this.dataTableValue.length; rowIndex++ ) {
                                    this.revertCellContent( columnField, this.dataTableValue[ rowIndex ].rowData, event.originalEvent, batchCtx );
                                }

                                dispatch( setElusiveData( this.props.uid, {
                                    cellEditorValues : batchCtx.cellEditorValues,
                                    cellEditorErrors : batchCtx.cellEditorErrors,
                                    changedCellValues: batchCtx.changedCellValues
                                } ) );
                            } );
                        }
                    } );
                }

                // open in separate view
                if ( rowRootItem ) {
                    if ( retVal.length ) {
                        retVal.push( { separator: true } );
                    }
                    retVal.push(
                        {
                            label  : __( 'YN.base.frontend.dataTable.contextMenu.openInView' ),
                            icon   : 'pi pi-external-link yn-blue',
                            command: ( event : MenuItemCommandEvent ) => {
                                const mouseEvent = event.originalEvent as unknown as React.MouseEvent<HTMLElement>;

                                if ( !this.props.onRowClick?.( columnField, rowData, mouseEvent ) ) {
                                    this.openDetailPanelForCell( rowData, mouseEvent );
                                }
                            }
                        }
                    );
                }

                // use in filter
                if ( retVal.length ) {
                    retVal.push( { separator: true } );
                }
                retVal.push( {
                    label  : __( 'YN.base.frontend.dataTable.contextMenu.useInFilter' ),
                    icon   : 'pi pi-filter yn-blue',
                    command: ( event : MenuItemCommandEvent ) => {
                        const columnFilter     = ( elusiveData?.newFilters ?? filters ).find( filter => columnField === filter.field ),
                              columnDefinition = columnDefinitions.find( colDef => columnField === colDef.field ),
                              valueType        = ( columnDefinition ? dataUtils.getDataValueType( columnDefinition.dataDescriptor, schema, dataStructure ) : undefined ) ?? 'STRING',
                              filterMatchMode  = columnFilter?.operator ?? getDefaultFilterMatchMode( valueType );

                        let filterValue = this.getCellValue( columnField, rowData )?.value;

                        if ( filterMatchMode && filterValue && this.renderedFilterRefs[ columnField ] ) {
                            if ( isPropertyValueType( valueType ) ) {
                                filterValue = convertValueToString( filterValue, valueType );
                            }
                            this.renderedFilterRefs[ columnField ].updateFilterValue( filterValue, filterMatchMode );
                            this.onFilterChange( columnKey, columnField, filterMatchMode, filterValue, valueType );
                        }
                    }
                } );

                // copy
                if ( retVal.length ) {
                    retVal.push( { separator: true } );
                }
                retVal.push( {
                    label  : __( 'YN.base.frontend.dataTable.contextMenu.copyCellValue' ),
                    icon   : 'pi pi-copy yn-blue',
                    command: ( event : MenuItemCommandEvent ) => {
                        if ( cellValue?.value ) {
                            let value = cellValue?.value;

                            if ( cellValue.valueType === 'DATE' || cellValue.valueType === 'TIME' || cellValue.valueType === 'TIMESTAMP' ) {
                                value = convertValueToString( value, cellValue.valueType );
                            }

                            void navigator.clipboard.writeText( value );
                        }
                    }
                } );
                retVal.push( {
                    label  : __( 'YN.base.frontend.dataTable.contextMenu.copyRowValue' ),
                    icon   : 'pi pi-copy yn-blue',
                    command: this.copyRowToClipboard.bind( this, rowData )
                } );
                retVal.push( {
                    label  : __( 'YN.base.frontend.dataTable.contextMenu.copyTableValue' ),
                    icon   : 'pi pi-copy yn-blue',
                    command: this.copyTableToClipboard.bind( this )
                } );
            }
        }

        return retVal;
    }

    /**
     * Reverts the modification of a cells content.
     *
     * @param {string} columnField
     * @param {LoadMetaDataRowData} rowData
     *
     * @return {void}
     */
    revertCellContent( columnField : string, rowData : LoadMetaDataRowData, event : React.SyntheticEvent, batchCtx? : BatchContext ) {
        const {
                  uid,
                  dataContext,
                  schema,
                  value,
                  elusiveData
              }                     = this.props,
              changedCellValues     = batchCtx ? batchCtx.changedCellValues : { ...elusiveData?.changedCellValues ?? {} },
              cellEditorValues      = batchCtx ? batchCtx.cellEditorValues : { ...elusiveData?.cellEditorValues ?? {} },
              cellEditorErrors      = batchCtx ? batchCtx.cellEditorErrors : { ...elusiveData?.cellEditorErrors ?? {} },
              cellValue             = this.getCellValue( columnField, rowData ),
              dispatch              = batchCtx?.dispatch,
              attributesToSet : any = {};

        if ( cellValue && cellValue.dataDescriptor.attribute && !cellValue.dataDescriptor.aggregate ) {
            const dataDescriptor = cellValue.dataDescriptor;

            let cellObject : Item | Property | Reference | ReferenceProperty | undefined;

            try {
                switch ( dataDescriptor.type ) {
                    case 'item':
                        cellObject = getItemForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        if ( cellObject ) {
                            attributesToSet[ dataDescriptor.attribute ] = cellObject.attributesModified.get( dataDescriptor.attribute as keyof ItemOnlyAttributesSettable );

                            if ( dispatch ) {
                                dispatch( updateItem( dataContext, cellObject.id, attributesToSet ) );
                            }
                            else {
                                this.props.updateItem( dataContext, cellObject.id, attributesToSet );
                            }
                        }

                        break;

                    case 'property':
                        cellObject = getPropertyForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        if ( deletedStatusId[ schema ] === undefined ) {
                            resetStatusIdCaches();
                        }

                        if ( cellObject ) {

                            // revert existing one or if it has more than one modification
                            if ( !cellObject.isNew() || cellObject.attributesModified.size > 1 ) {
                                attributesToSet[ dataDescriptor.attribute ] = cellObject.attributesModified.get( dataDescriptor.attribute as keyof PropertyAttributesSettable );

                                // revert deletion
                                if ( cellObject.isAttributeModified( 'statusId' ) && cellObject.statusId === deletedStatusId[ schema ] ) {
                                    attributesToSet.statusId = cellObject.attributesModified.get( 'statusId' );
                                }

                                if ( cellObject.propertySet.isEnumerated ) {
                                    this.setEnumPropertyAttributes( cellObject.itemId, cellObject.propertySet.propertyTypeId, cellObject.stringKey, attributesToSet, dispatch );
                                }
                                else {
                                    this.setPropertyAttributes( cellObject.itemId, cellObject.propertySet.propertyTypeId, attributesToSet, dispatch );
                                }
                            }

                            // remove new one
                            else if ( deletedStatusId[ schema ] ) {
                                attributesToSet[ 'statusId' ] = deletedStatusId[ schema ];

                                if ( cellObject.propertySet.isEnumerated ) {
                                    this.setEnumPropertyAttributes( cellObject.itemId, cellObject.propertySet.propertyTypeId, cellObject.stringKey, attributesToSet, dispatch );
                                }
                                else {
                                    this.setPropertyAttributes( cellObject.itemId, cellObject.propertySet.propertyTypeId, attributesToSet, dispatch );
                                }
                            }
                        }

                        break;

                    case 'reference':
                        cellObject = getReferenceForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        if ( cellObject ) {
                            attributesToSet[ dataDescriptor.attribute ] = cellObject.attributesModified.get( dataDescriptor.attribute as keyof ReferenceOnlyAttributesSettable );

                            if ( dispatch ) {
                                dispatch( updateReference( dataContext, cellObject.id, attributesToSet ) );
                            }
                            else {
                                this.props.updateReference( dataContext, cellObject.id, attributesToSet );
                            }
                        }

                        break;

                    case 'referenceProperty':
                        cellObject = getReferencePropertyForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        if ( deletedStatusId[ schema ] === undefined ) {
                            resetStatusIdCaches();
                        }

                        if ( cellObject ) {

                            // revert existing one or if it has more than one modification
                            if ( !cellObject.isNew() || cellObject.attributesModified.size > 1 ) {
                                attributesToSet[ dataDescriptor.attribute ] = cellObject.attributesModified.get( dataDescriptor.attribute as keyof ReferencePropertyAttributesSettable );

                                // revert deletion
                                if ( cellObject.isAttributeModified( 'statusId' ) && cellObject.statusId === deletedStatusId[ schema ] ) {
                                    attributesToSet.statusId = cellObject.attributesModified.get( 'statusId' );
                                }

                                if ( cellObject.referencePropertySet.isEnumerated ) {
                                    this.setEnumReferencePropertyAttributes( cellObject.referenceId, cellObject.referencePropertySet.propertyTypeId, cellObject.stringKey, attributesToSet, dispatch );
                                }
                                else {
                                    this.setReferencePropertyAttributes( cellObject.referenceId, cellObject.referencePropertySet.propertyTypeId, attributesToSet, dispatch );
                                }
                            }

                            // remove new one
                            else if ( deletedStatusId[ schema ] ) {
                                attributesToSet[ 'statusId' ] = deletedStatusId[ schema ];

                                if ( cellObject.referencePropertySet.isEnumerated ) {
                                    this.setEnumReferencePropertyAttributes( cellObject.referenceId, cellObject.referencePropertySet.propertyTypeId, cellObject.stringKey, attributesToSet, dispatch );
                                }
                                else {
                                    this.setReferencePropertyAttributes( cellObject.referenceId, cellObject.referencePropertySet.propertyTypeId, attributesToSet, dispatch );
                                }
                            }
                        }

                        break;
                }

                // clear edit value and errors
                delete cellEditorValues[ cellValue.cellId ];
                delete cellEditorErrors[ cellValue.cellId ];
            }
            catch ( e ) {
                if ( e instanceof Error || typeof e === 'string' ) {
                    const stringifiedRowData = JSON.stringify( rowData );

                    cellEditorErrors[ cellValue.cellId ] = {
                        field   : columnField,
                        rowIndex: ( value?.findIndex( valueRowData => JSON.stringify( valueRowData ) === stringifiedRowData ) ?? -1 ) + 1,
                        messages: [ String( e ) ]
                    };
                }
            }

            // in batch mode the caller emits one setElusiveData after the loop
            if ( !batchCtx ) {
                this.props.setElusiveData( uid, {
                    cellEditorValues,
                    cellEditorErrors
                } );
            }
        }
        else if ( cellValue && cellValue.dataDescriptor.type === 'static' ) {
            const rowId = DataTable.getRowId( rowData );

            // clear changed value
            changedCellValues[ rowId ] = {
                ...changedCellValues[ rowId ]
            };
            delete changedCellValues[ rowId ][ columnField ];

            // clear edit value and errors
            delete cellEditorValues[ cellValue.cellId ];
            delete cellEditorErrors[ cellValue.cellId ];

            void this.props.onRowDataRevert?.( columnField, { ...rowData }, event, changedCellValues );

            if ( !batchCtx ) {
                this.props.setElusiveData( uid, {
                    changedCellValues,
                    cellEditorValues,
                    cellEditorErrors
                } );
            }
        }
    }

    /**
     * Deletes the modification of a cells content (only properties and referenceProperties)
     *
     * @param {string} columnField
     * @param {LoadMetaDataRowData} rowData
     *
     * @return {void}
     */
    deleteCellContent( columnField : string, rowData : LoadMetaDataRowData, batchCtx? : BatchContext ) {
        const {
                  uid,
                  schema,
                  dataContext,
                  value,
                  elusiveData
              }                     = this.props,
              cellEditorValues      = batchCtx ? batchCtx.cellEditorValues : { ...elusiveData?.cellEditorValues ?? {} },
              cellEditorErrors      = batchCtx ? batchCtx.cellEditorErrors : { ...elusiveData?.cellEditorErrors ?? {} },
              cellValue             = this.getCellValue( columnField, rowData ),
              dispatch              = batchCtx?.dispatch,
              attributesToSet : any = {};

        if ( cellValue && !cellValue.dataDescriptor.aggregate ) {
            const dataDescriptor = cellValue.dataDescriptor;

            let cellObject : Item | Property | Reference | ReferenceProperty | undefined;

            if ( deletedStatusId[ schema ] === undefined ) {
                resetStatusIdCaches();
            }

            try {

                switch ( dataDescriptor.type ) {
                    case 'property':
                        cellObject = getPropertyForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        if ( cellObject ) {
                            if ( deletedStatusId[ schema ] ) {
                                attributesToSet[ 'statusId' ] = deletedStatusId[ schema ];

                                if ( cellObject.propertySet.isEnumerated ) {
                                    this.setEnumPropertyAttributes( cellObject.itemId, cellObject.propertySet.propertyTypeId, cellObject.stringKey, attributesToSet, dispatch );
                                }
                                else {
                                    this.setPropertyAttributes( cellObject.itemId, cellObject.propertySet.propertyTypeId, attributesToSet, dispatch );
                                }
                            }
                        }

                        break;

                    case 'referenceProperty':
                        cellObject = getReferencePropertyForDataDescriptorFromRowData( dataContext, dataDescriptor, rowData );

                        if ( cellObject ) {
                            if ( deletedStatusId[ schema ] ) {
                                attributesToSet[ 'statusId' ] = deletedStatusId[ schema ];

                                if ( cellObject.referencePropertySet.isEnumerated ) {
                                    this.setEnumReferencePropertyAttributes( cellObject.referenceId, cellObject.referencePropertySet.propertyTypeId, cellObject.stringKey, attributesToSet, dispatch );
                                }
                                else {
                                    this.setReferencePropertyAttributes( cellObject.referenceId, cellObject.referencePropertySet.propertyTypeId, attributesToSet, dispatch );
                                }
                            }
                        }

                        break;
                }

                delete cellEditorValues[ cellValue.cellId ];
            }
            catch ( e ) {
                if ( e instanceof Error || typeof e === 'string' ) {
                    const stringifiedRowData = JSON.stringify( rowData );

                    cellEditorErrors[ cellValue.cellId ] = {
                        field   : columnField,
                        rowIndex: ( value?.findIndex( valueRowData => JSON.stringify( valueRowData ) === stringifiedRowData ) ?? -1 ) + 1,
                        messages: [ String( e ) ]
                    };
                }
            }

            // in batch mode the caller emits one setElusiveData after the loop
            if ( !batchCtx ) {
                this.props.setElusiveData( uid, {
                    cellEditorValues,
                    cellEditorErrors
                } );
            }
        }
    }

    /**
     * Opens detail panel for given cell
     *
     * @param {string} columnField
     * @param {LoadMetaDataRowData} rowData
     * @param {React.MouseEvent<HTMLElement, MouseEvent>} event
     *
     * @return {void}
     */
    openDetailPanelForCell( rowData : LoadMetaDataRowData, event : React.MouseEvent<HTMLElement, MouseEvent> ) {
        const {
                  dataContext,
                  dataStructure,
                  user
              }                           = this.props,
              rowRootItemIdDataDescriptor = buildDataDescriptor( { attributePath: 'item.id' }, dataStructure ) as ItemDataDescriptor,
              rowRootItemId               = rowData[ rowRootItemIdDataDescriptor?.alias ],
              rowRootItem                 = global.data[ dataContext ]?.items[ rowRootItemId ];

        if ( rowRootItem ) {
            if ( !rowRootItem.isDeleted() ) {
                this.props.openPanelForItemType(
                    this.props.schema,
                    rowRootItem.itemType.name,
                    {
                        schema   : this.props.schema,
                        status   : this.props.status !== 'all' ? this.props.status : 'all-non-history',
                        timestamp: this.props.timestamp,
                        timezone : this.props.timezone,
                        //
                        rootItemId: rowRootItem.id,
                        //
                        rawMode               : this.props.rawMode,
                        showAdditionalRawNames: this.props.showAdditionalRawNames
                    },
                    undefined,
                    event,
                    undefined,
                    [ 'FinderOverview', 'Overview', 'XmlImport' ]
                );
            }

            else if ( user?.hasGenericPermissionOnItemType( 'read', rowRootItem.itemType ) ) {
                this.props.openPanel( {
                    panelType: 'FinderDetail',
                    //
                    schema   : this.props.schema,
                    status   : this.props.status,
                    timestamp: this.props.timestamp,
                    timezone : this.props.timezone,
                    //
                    rootItemId: rowRootItem.id,
                    //
                    rawMode               : this.props.rawMode,
                    showAdditionalRawNames: this.props.showAdditionalRawNames
                } );
            }
        }
    }

    copyRowToClipboard( rowData : LoadMetaDataRowData, event : MenuItemCommandEvent ) {
        void navigator.clipboard.writeText( this.getCsvValueForRow( rowData ) );
    }

    copyTableToClipboard( event : MenuItemCommandEvent ) {
        const {
                  elusiveData
              } = this.props;

        if ( elusiveData?.metaData?.rowData ) {
            let value : string = '';

            for ( const rowData of elusiveData.metaData.rowData ) {
                value += `${value ? '\r\n' : ''}${this.getCsvValueForRow( rowData )}`;
            }

            void navigator.clipboard.writeText( value );
        }
    }

    getCsvValueForRow( rowData : LoadMetaDataRowData ) {
        const {
                  columnDefinitions,
                  columns,
                  dataStructure,
                  schema
              }        = this.props,
              rowValue = this.getRowValues( rowData );

        let retVal : string = '';

        for ( const column of columns ) {
            const columnDefinition = columnDefinitions.find( colDef => column.field === colDef.field ),
                  valueType        = ( columnDefinition ? dataUtils.getDataValueType( columnDefinition.dataDescriptor, schema, dataStructure ) : undefined ) ?? 'STRING';

            retVal += retVal ? ',' : '';

            if ( rowValue[ column.field ] === null || rowValue[ column.field ] === undefined ) {
                if ( !( valueType === 'BOOLEAN' || valueType === 'CURRENCY' || valueType === 'DOUBLE' || valueType === 'DURATION' || valueType === 'INTEGER' || valueType === 'STATUSID' ) ) {
                    retVal += '""';
                }
            }
            else if ( valueType === 'BOOLEAN' || valueType === 'CURRENCY' || valueType === 'DOUBLE' || valueType === 'DURATION' || valueType === 'INTEGER' || valueType === 'STATUSID' ) {
                retVal += rowValue[ column.field ];
            }
            else if ( valueType === 'DATE' || valueType === 'TIME' || valueType === 'TIMESTAMP' ) {
                retVal += `"${convertValueToString( rowValue[ column.field ], valueType )}"`;
            }
            else if ( valueType === 'JSON' || valueType === 'STRING' || valueType === 'TEXT' || valueType === 'TIMERULE' ) {
                retVal += `"${rowValue[ column.field ]?.replaceAll( '"', '\\"' ).replaceAll( /(\r|\n)+/g, '\\r\\n' )}"`;
            }
            else {
                retVal += `"${rowValue[ column.field ]}"`;
            }
        }

        return retVal;
    }

    /**
     * Checks the given key for uniqueness within the given ItemType against the backend.
     *
     * @private
     */
    checkKeyUniqueness( item : Item, key : string, cellId : string, columnField : string, rowIndex : number ) : boolean {
        const {
                  uid,
                  dataContext,
                  schema,
                  elusiveData
              }          = this.props,
              requestUid = 'checkKeyUniqueness';

        let retVal = true;

        if ( item && key ) {
            // no check needed if key was checked (item.key) or is original one (item.attributesModified.get( 'key' ))
            if ( key !== item.key && key !== item.attributesModified.get( 'key' ) ) {
                // abort running check
                if ( this.props.xhrRequestsForComponent?.[ requestUid ] ) {
                    xhr.abort( uid, requestUid );
                }

                const params : CheckItemKeyUniquenessParameters = {
                          schema,
                          status  : 'all',
                          itemType: item.itemType.id,
                          key
                      },
                      doLoad                                    = async () => {
                          const response = await xhr.post(
                              `${BASE_URL}/api/data/checkItemKeyUniqueness`,
                              params,
                              undefined,
                              `${uid}_check`,
                              requestUid
                          );

                          if ( response?.data ) {
                              const responseData = response.data as CheckItemKeyUniquenessResult;

                              if ( responseData.success ) {
                                  const cellEditorErrors = { ...elusiveData?.cellEditorErrors ?? {} };

                                  if ( !responseData.data.keyIsUnique ) {
                                      cellEditorErrors[ cellId ] = {
                                          field   : columnField,
                                          rowIndex,
                                          messages: [ __( 'YN.base.frontend.dataTable.item.key.error.notUnique' ) ]
                                      };
                                  }
                                  else {
                                      const editCell = { ...elusiveData?.editCell ?? {} };

                                      delete cellEditorErrors[ cellId ];

                                      // set value if editor is no more active
                                      if ( editCell.cellId !== cellId ) {
                                          this.props.updateItem( dataContext, item.id, { key } );
                                      }
                                  }

                                  this.props.setElusiveData( uid, { cellEditorErrors } );
                              }
                          }
                      };

                void doLoad();
            }

            // no check needed -> no error
            else {
                const cellEditorErrors = { ...elusiveData?.cellEditorErrors ?? {} };

                retVal = false;

                delete cellEditorErrors[ cellId ];

                this.props.setElusiveData( uid, { cellEditorErrors } );
            }
        }

        return retVal;
    }

    /**
     * Gets the columnField for a mouse event if it is possible
     * @param event
     */
    getKeyAndFieldForMouseEvent( event : React.MouseEvent<HTMLElement> ) : { key : string; field : string } {
        let retVal : { key : string; field : string } = { key: '', field: '' };

        const {
                  actionColumns
              }             = this.props,
              targetElement = event.target as unknown as Element;

        // get TD element
        let cellElement : Element | null       = targetElement.parentElement,
            cellNode : Node | null | undefined = targetElement.parentNode;
        while ( cellElement !== null && cellElement.tagName !== 'TD' ) {
            cellElement = cellElement.parentElement;
            cellNode = cellNode?.parentNode;
        }

        // get row
        const rowElement = cellElement?.parentElement;

        // get columnIndex
        let columnIndex : number | undefined;
        if ( rowElement ) {
            for ( let i = 0; i < rowElement.childNodes.length; i++ ) {
                if ( rowElement.childNodes[ i ] === cellNode ) {
                    columnIndex = i - Object.keys( actionColumns ).length;
                    break;
                }
            }
        }

        // get field
        if ( columnIndex !== undefined ) {
            retVal = {
                key  : this.props.columns[ columnIndex ]?.key ?? this.props.columns[ columnIndex ]?.field.replace( /[.: ()]/g, '_' ),
                field: this.props.columns[ columnIndex ]?.field
            };
        }

        return retVal;
    }

    /**
     * Renders a single column.
     *
     * @param {Schema} schema
     * @param {DefaultConfigDescriptor} columnDefaults
     * @param {ColumnDefinition} columnDefinition
     * @param {ColumnConfig} columnConfiguration
     * @param {DataStructure} dataStructure
     * @param {Boolean} rawMode
     * @param {Boolean} showAdditionalRawNames
     * @param {Boolean} editMode
     *
     * @return {JSX.Element|undefined}
     *
     * @private
     */
    buildColumn( schema : Schema, columnDefaults : DefaultConfigDescriptor, columnDefinition : ColumnDefinition, columnConfiguration : ColumnConfig, dataStructure : DataStructure, rawMode : boolean, showAdditionalRawNames : boolean, editMode : boolean, filterable : boolean, sortable : boolean ) : JSX.Element | undefined {
        let retVal : JSX.Element | undefined;

        if ( Object.keys( dataStructure ).length ) {
            const valueType                     = dataUtils.getDataValueType( columnDefinition.dataDescriptor, schema, dataStructure ) ?? 'STRING',
                  styleProps : ColumnStyleProps = {
                      // defaults
                      ...( _.pick( columnDefaults, columnStylePropsKeys ) as Partial<ColumnStyleProps> ),

                      // definition
                      ...( _.pick( columnDefinition, columnStylePropsKeys ) as Partial<ColumnStyleProps> ),

                      // config
                      ...( _.pick( columnConfiguration, columnStylePropsKeys ) as Partial<ColumnStyleProps> )
                  };

            // apply type depending on style defaults
            if ( !styleProps.align ) {
                switch ( valueType ) {
                    case 'BOOLEAN':
                        styleProps.align = 'center';
                        break;

                    case 'CURRENCY':
                    case 'DOUBLE':
                    case 'INTEGER':
                        styleProps.align = 'right';
                        break;

                    default:
                        styleProps.align = 'left';
                        break;
                }
            }

            // extract column properties
            const columnProps : ColumnProps & {
                key : string;
            } = {
                hidden: false,

                // defaults
                ...( _.pick( columnDefaults, columnPropsKeys ) as Partial<ColumnProps> ),

                // definition
                ...( _.pick( columnDefinition, columnPropsKeys ) as Partial<ColumnProps> ),

                // config
                ...( _.pick( columnConfiguration, columnPropsKeys ) as Partial<ColumnProps> ),

                header         : getColumnHeader( columnDefinition, dataStructure, schema, rawMode, showAdditionalRawNames ),
                headerClassName: `${columnDefaults.headerClassName ? columnDefaults.headerClassName : ''}${columnDefinition.headerStyling ? ` ${resolveStyleToClassNames( columnDefinition.headerStyling, {}, 'headerCell', [ '.${className} .p-column-title' ] ).join( ' ' )}` : ''}`,
                headerStyle    : styleProps.align ? { justifyContent: styleProps.align } : undefined,
                footer         : columnDefinition.footer ? this.getColumnFooter.bind( this, columnDefinition.key ?? columnDefinition.field.replace( /[.: ()]/g, '_' ), columnDefinition.footer ) : null,
                key            : columnDefinition.key ?? columnDefinition.field.replace( /[.: ()]/g, '_' ),
                columnKey      : columnDefinition.field,
                style          : processColumnStyle( styleProps ),
                pt             : {
                    ...columnDefinition.pt,
                    ...columnConfiguration.pt,
                    headerCell: {
                        onClickCapture: this.onColumnHeaderClick.bind( this, columnDefinition ),
                        ...columnDefinition.pt?.headerCell,
                        ...columnConfiguration.pt?.headerCell
                    }
                }
            };

            columnProps.filter = filterable && columnProps.filter;
            columnProps.sortable = sortable && ( columnProps.sortable ?? true );

            // editor
            if ( editMode && columnDefinition.editor && isColumnEditable( columnDefinition.dataDescriptor, dataStructure, schema, columnDefinition.permissions ) ) {
                const columnEditorProps : ColumnEditorProps = {
                    field              : columnDefinition.field,
                    dataDescriptor     : columnDefinition.dataDescriptor,
                    valueType,
                    style              : columnProps.style,
                    permissions        : columnDefinition.permissions ?? {},
                    defaultValue       : columnDefinition.editorDefaultValue,
                    helpText           : columnDefinition.editorHelpText,
                    validatorRegExp    : columnDefinition.editorValidatorRegExp,
                    validationErrorText: columnDefinition.editorValidationErrorText,
                    editorConfig       : columnDefinition.editorConfig
                };

                columnProps.editor = this.getEditor.bind( this, columnEditorProps );

                columnProps.onBeforeCellEditShow = this.onBeforeCellEditShow.bind( this, columnEditorProps );
                columnProps.onCellEditComplete = this.onCellEditComplete.bind( this, columnEditorProps );
                columnProps.onCellEditCancel = this.onCellEditCancel.bind( this, columnEditorProps );
            }
            else {
                delete columnProps.editor;
            }

            // filter
            if ( columnProps.filter ) {
                columnProps.filterElement = this.getFilter;
                columnProps.showFilterMenu = false;
                columnProps.showClearButton = false;
            }

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            if ( !columnProps.pt?.headerCell?.[ 'data-datadescriptoralias' ] ) {
                columnProps.pt = {
                    ...columnProps.pt,
                    headerCell: {
                        ...columnProps.pt?.headerCell,
                        [ 'data-datadescriptoralias' ]: `${columnDefinition.dataDescriptor?.alias ? `${columnDefinition.dataDescriptor.alias} ` : ''}${columnDefinition.dataDescriptor?.fullAlias !== columnDefinition.dataDescriptor?.alias ? columnDefinition.dataDescriptor?.fullAlias.split( ',' ).join( ' ' ) ?? '' : ''}`
                    }
                }
            }

            retVal = <Column
                {...columnProps}
                pt={{
                    ...columnProps.pt,
                    columnResizer: {
                        ...columnProps.pt?.columnResizer,
                        onMouseDownCapture: ( e : React.MouseEvent ) => {
                            ( columnProps.pt?.columnResizer as any )?.onMouseDownCapture?.( e );
                            this.onColumnResizeDragStart();
                        },
                        onMouseUp         : ( e : React.MouseEvent ) => {
                            ( columnProps.pt?.columnResizer as any )?.onMouseUp?.( e );
                            this.onColumnResizeDragEnd();
                        }
                    }
                }}
            />;
        }

        return retVal;
    }

    /**
     * Renders a single filter field for column.
     *
     * @param {AllProps} props
     * @param {string} field
     * @param {DataDescriptor} dataDescriptor
     * @param {ColumnFilter} [filter]
     * @param {ColumnFilter} [fixFilter]
     * @param {FilterConfig} [filterConfig]
     *
     * @return {JSX.Element|undefined}
     *
     * @private
     */
    buildFilter( props : AllProps, fieldKey : string, field : string, dataDescriptor : DataDescriptor, filter? : ColumnFilter, fixFilter? : ColumnFilter, filterConfig? : FilterConfig ) : JSX.Element {
        const {
                  schema,
                  timezone,
                  dataStructure,
                  rawMode,
                  showAdditionalRawNames,
                  elusiveData
              }                           = props,
              filterParams : FilterConfig = {
                  schema,
                  timezone,
                  rawMode,
                  showAdditionalRawNames
              },
              valueType                   = dataUtils.getDataValueType( dataDescriptor, schema, dataStructure ) ?? 'STRING',
              filterValue                 = fixFilter?.value ?? filter?.value ?? '',
              filterOperator              = fixFilter?.operator ?? filter?.operator;

        let retVal : JSX.Element = <></>;

        if ( dataDescriptor.type === 'property' && dataDescriptor.dataObject.item.objectType ) {
            const propertySet = metaModel[ schema ].getPropertySetForItemTypeAndPropertyType( dataDescriptor.dataObject.item.objectType, dataDescriptor.propertyTypeName );

            if ( propertySet ) {
                filterParams.valueSetId = propertySet.valueSetId ? propertySet.valueSetId : undefined;
                filterParams.valueUnit = propertySet.valueUnit ? propertySet.valueUnit : undefined;
            }
        }
        else if ( dataDescriptor.type === 'referenceProperty' ) {
            const dataObject = getDataObject( dataDescriptor.dataObject.id, dataStructure );

            if ( dataObject ) {
                const referenceSets = getReferenceSetsForDataObject( dataDescriptor.dataObject, dataStructure, schema );

                if ( referenceSets.length === 1 ) {
                    const referencePropertySet = metaModel[ schema ].getReferencePropertySetForReferenceSetAndPropertyType( referenceSets[ 0 ].id, dataDescriptor.propertyTypeName );

                    if ( referencePropertySet ) {
                        filterParams.valueSetId = referencePropertySet.valueSetId ? referencePropertySet.valueSetId : undefined;
                        filterParams.valueUnit = referencePropertySet.valueUnit ? referencePropertySet.valueUnit : undefined;
                    }
                }
            }
        }

        retVal = <FilterField
            key={`${field}_filter_${elusiveData?.forceFilterToggle ?? 0}`}

            ref={element => {
                if ( element ) {
                    this.renderedFilterRefs[ field ] = element;
                }
                else {
                    delete this.renderedFilterRefs[ field ];
                }
            }}

            fieldKey={fieldKey}
            field={field}

            value={filterValue}
            valueType={valueType}
            matchMode={filterOperator}
            showMatchModeSelector={true}

            disabled={!!fixFilter}
            markDirty={!fixFilter}

            onChange={props.onFilterChange ?? this.onFilterChange}
            onEnterKey={props.onFilterEnterKey ?? this.onFilterEnterKey}

            changeDebounceMs={250}

            params={{
                ...filterParams,
                ...filterConfig
            }}
        />;

        return retVal;
    }

    /**
     * Renderer for cell
     *
     * @param {AllProps} props
     * @param {ColumnDefinition} columnDefinition
     * @param {CellProps} cellProps
     * @param {string} field
     * @param {CellValue} cellValue
     * @param {LoadMetaDataRowData} rowData
     * @param {number} rowIndex
     *
     * @return {JSX.Element | string | undefined}
     */
    buildCell( props : AllProps, columnDefinition : ColumnDefinition, cellProps : CellProps, field : string, cellValue : CellValue, rowData : LoadMetaDataRowData, rowIndex : number ) : React.ReactNode {
        const {
                  schema,
                  timezone,
                  dataContext,
                  dataStructure,
                  actionColumns,
                  rawMode,
                  showAdditionalRawNames,
                  noMultiLineCells,
                  editMode,
                  user,
                  valueFieldMapping
              }                                  = props,
              {
                  filterString,
                  format,
                  styling,
                  tooltip,
                  editable
              }                                  = cellProps,
              renderValueParams : any            = {
                  schema,
                  timezone,
                  language   : user?.language,
                  filterString,
                  showAdditionalRawNames,
                  valueUnit  : cellValue.valueUnit,
                  valuePrecision,
                  onlyOneLine: noMultiLineCells,
                  editMode
              },
              cellId                             = `cell_${cellValue.cellId}_${rowIndex}`,
              classNames : string[]              = [ 'yn-cell-rendered-value-el' ],
              tooltipContent : React.ReactNode[] = [],
              valueToUse                         = cellValue.editValue !== undefined ? cellValue.editValue : cellValue.value,
              rawValues                          = Array.isArray( valueToUse )
                  ? valueToUse
                  : [ valueToUse ],
              values                             = rawValues,
              renderedValues : React.ReactNode[] = [];

        let retVal : React.ReactNode                     = '',
            rowValues : DataDescriptorValues | undefined = undefined,
            customTooltip : string | undefined           = undefined;

        for ( let i = 0; i < values.length; i++ ) {
            const rawValue = rawValues[ i ];

            let value = values[ i ];

            // resolve ValueSet value if
            if ( cellValue.valueSetId ) {
                const valueToDisplay = isPropertyValueType( cellValue.valueType )
                          ? convertValueToString( value as AttributeValue, cellValue.valueType )
                          : String( value ),
                      filterStrings  = renderValueParams.filterString?.split( /\|\||&&/ ) ?? [];

                value = getValueDisplayName( cellValue.valueSetId, valueToDisplay, schema, rawMode, showAdditionalRawNames );

                for ( const filter of filterStrings ) {
                    renderValueParams.filterString = renderValueParams.filterString.replace( filter, getValueDisplayName( cellValue.valueSetId, filter, schema, rawMode, showAdditionalRawNames ) );
                }
            }

            if ( value !== undefined && value !== null && String( value ).trim() !== '' ) {
                // format
                if ( !rawMode && format ) {
                    const valueToFormat = format.type === 'Image'
                        ? Array.isArray( rawValue )
                            ? rawValue.join( '::rn::' )
                            : String( rawValue )
                        : isPropertyValueType( cellValue.valueType )
                            ? convertValueToString( value as AttributeValue, cellValue.valueType )
                            : String( value );

                    if ( format.type === 'Image' && !format.options?.height && !format.options?.width ) {
                        format.options = {
                            ...format.options,
                            height  : '14',
                            maxWidth: format.options?.maxWidth ?? 'none'
                        };
                    }

                    if ( rowValues === undefined ) {
                        rowValues = this.getRowValues( rowData );
                    }

                    value = formatRenderer(
                        valueToFormat,
                        {
                            ...format,
                            data: {
                                ...rowValues,
                                tooltipId: `#${cellId}_customTooltip`
                            }
                        },
                        renderValueParams.filterString
                    );

                    if (
                        ( rawValue === null && value === 'null' )
                        || ( rawValue === undefined && value === 'undefined' )
                    ) {
                        value = rawValue;
                    }

                    if ( Array.isArray( value ) ) {
                        const recursiveLookForTooltip = ( nodes : React.ReactNode[] ) => {
                            for ( let k = 0; k < nodes.length; k++ ) {

                                if ( nodes[ k ] && typeof nodes[ k ] === 'object' ) {
                                    const node = nodes[ k ] as React.ReactElement;
                                    if ( node.props?.[ 'data-pr-tooltip' ] ) {
                                        customTooltip = node.props?.[ 'data-pr-tooltip' ];
                                        break;
                                    }

                                    if ( node.props?.children ) {
                                        recursiveLookForTooltip( node.props.children as React.ReactNode[] );
                                    }
                                }
                            }
                        }

                        recursiveLookForTooltip( value );
                    }
                }

                // normal
                else {
                    value = renderValue(
                        cellValue.valueType,
                        Array.isArray( rawValue ) || cellValue.valueSetId
                            ? value
                            : rawValue,
                        renderValueParams,
                        rawMode
                    );
                }
            }

            if (
                value !== undefined && value !== null && String( value ).trim() !== ''
                && typeof value === 'string'
                && !isInvalidHTML( value )
            ) {
                value = parse( value );
            }

            // styling
            if ( styling ) {
                if ( rowValues === undefined ) {
                    rowValues = this.getRowValues( rowData );
                }

                value = stylingRenderer( value, styling, rowValues, 'cell' );
            }

            // default value
            if ( cellValue.isDefault ) {
                classNames.push( 'property-default' );
            }

            // error
            if ( cellValue.editorErrorMessages ) {
                classNames.push( 'yn-error-border' );

                tooltipContent.push(
                    <div key="error" className="yn-tooltip-error">
                        <div className="yn-tooltip-header">
                            {__( 'YN.base.common.tooltip.error.title' )}
                        </div>
                        {cellValue.editorErrorMessages.map( message => <>{message}<br/></> )}
                    </div>
                );
            }

            // deleted
            else if ( cellValue.isDeleted && cellValue.isModified ) {
                classNames.push( 'yn-dirty-border' );

                if ( editMode ) {
                    classNames.push( 'yn-disabled' );
                }
            }

            // disabled (editMode only)
            else if ( editMode && !Object.keys( actionColumns ).includes( field ) && ( !editable || !cellValue.isEditable ) ) {
                classNames.push( 'yn-disabled' );
            }

            // new
            else if ( cellValue.isNew ) {
                classNames.push( 'yn-dirty-border' );
            }

            // modified
            else if ( cellValue.isModified ) {
                classNames.push( 'yn-dirty-border' );
            }

            if ( cellValue.statusId && !cellValue.isDefault ) {
                renderedValues.push( statusColoringRenderer( value, cellValue.statusId, schema, `cellValue_${i}`, `${cellId}_${i}` ) );
            }
            else {
                renderedValues.push( statusColoringRenderer( value, 0, schema, `cellValue_${i}`, `${cellId}_${i}` ) );
            }
        }

        if ( renderedValues.length > 1 ) {
            let stringListConcatenator : string = ', ',
                listConcatenator : React.ReactNode;

            if ( !rawMode && format?.type === 'Text' && format?.options?.listConcatenator ) {
                stringListConcatenator = format.options.listConcatenator;
            }

            stringListConcatenator = stringListConcatenator.replaceAll( ' ', '&nbsp;' );

            if ( !isInvalidHTML( stringListConcatenator as string ) ) {
                listConcatenator = parse( stringListConcatenator as string );
            }
            else {
                listConcatenator = stringListConcatenator;
            }

            for ( let i = renderedValues.length - 1; i > 0; i-- ) {
                renderedValues.splice( i, 0, listConcatenator );
            }
        }

        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        if ( tooltip || customTooltip ) {
            const cellItem         = getItemForDataDescriptorFromRowData( dataContext, cellValue.dataDescriptor, rowData ),
                  subDataStructure = getDataStructure( cellValue.dataDescriptor.dataObject?.id ?? '', dataStructure );

            let cellTooltip : string | undefined,
                rootItem : Item | undefined;

            if ( !cellItem || !subDataStructure ) {
                const rowRootItemIdDataDescriptor = buildDataDescriptor( { attributePath: 'item.id' }, dataStructure ) as ItemDataDescriptor,
                      rowRootItemId               = rowData[ rowRootItemIdDataDescriptor?.alias ];

                rootItem = global.data[ dataContext ]?.items[ rowRootItemId ];
            }

            if ( tooltip ) {
                if ( cellItem && subDataStructure ) {
                    cellTooltip = messageUtilities.resolveMessageForDataStructure( tooltip, subDataStructure, dataContext, cellItem );
                }
                else if ( rootItem && dataStructure ) {
                    cellTooltip = messageUtilities.resolveMessageForDataStructure( tooltip, dataStructure, dataContext, rootItem );
                }
                else if ( typeof tooltip === 'string' ) {
                    cellTooltip = tooltip;
                }
            }
            else {
                cellTooltip = customTooltip;
            }

            if ( cellTooltip ) {
                cellTooltip = messageUtilities.resolveMessageForQueryData(
                    cellTooltip,
                    Object.keys( rowData ).reduce(
                        ( innerRetVal, key ) => {
                            if ( valueFieldMapping?.[ key ] ) {
                                innerRetVal[ valueFieldMapping[ key ] ] = rowData[ key ];
                            }
                            return innerRetVal;
                        },
                        { ...rowData }
                    ),
                    ', '
                );
            }

            if ( cellTooltip ) {
                tooltipContent.push( parse( __( cellTooltip, this.getCellMessagePlaceholders( rowData, cellValue.dataDescriptor ) ) ) );
            }
        }

        if ( tooltipContent.length ) {
            retVal = <>
                <Tooltip
                    key="cellTooltip"
                    target={`#${cellId}`}
                    my="left top"
                    at="left bottom"
                    className="yn-tooltip"
                    showDelay={250}
                >
                    {tooltipContent}
                </Tooltip>
                <span className="p-column-title">
                    {getColumnHeader( columnDefinition, dataStructure, schema, rawMode, showAdditionalRawNames )}
                </span>
                <span id={cellId} className={`yn-cell-renderer-el ${classNames.join( ' ' )}`}>
                    {renderedValues}
                </span>
            </>;
        }
        else {
            retVal = <>
                <span className="p-column-title">
                    {getColumnHeader( columnDefinition, dataStructure, schema, rawMode, showAdditionalRawNames )}
                </span>
                <span id={cellId} className={`yn-cell-renderer-el ${classNames.join( ' ' )}`}>
                    {renderedValues}
                </span>
            </>;
        }

        return retVal;
    }

    /**
     * REACT lifecycle method
     */
    render() {
        const {
                  className,
                  dataKey,
                  editMode,
                  expandableRowGroups,
                  expandedRows,
                  filterDisplay,
                  footer,
                  groupRowsBy,
                  loading,
                  page,
                  paginatorTemplate,
                  pt,
                  reorderable,
                  resizable,
                  rowExpansionTemplate,
                  rowGroupFooterTemplate,
                  rowGroupHeaderTemplate,
                  rowGroupMode,
                  rows,
                  search,
                  selectable,
                  selection,
                  sorters,
                  totalRecords,
                  uid,
                  usePaging
              }            = this.props,
              emptyMessage = search ? '' : ' ';

        if ( this.columnResizeReset ) {
            this.columnResizeReset = false;
            this.dataTable?.resetResizeColumnsWidth();
        }

        let dataTableClassName  = 'p-datatable-striped yn-datatable',
            tableWidth : string = '100%';

        if ( className ) {
            dataTableClassName += ` ${className}`;
        }

        if ( Array.isArray( this.renderedColumns ) ) {
            const tableElement       = document.getElementById( `${uid}_datatable` ),
                  scrollSelector     = tableElement?.getAttribute( 'data-scrollselectors' ) ?? 'nothing',
                  scrollElement      = tableElement?.querySelector( scrollSelector ),
                  scrollElementWidth = scrollElement?.clientWidth ?? 0;

            let autoWidthColumnsCount = 0,
                fixedColumnsWidth     = 0;

            for ( const col of this.renderedColumns as React.ReactElement[] ) {
                if ( col?.props?.style?.width === 'auto' ) {
                    autoWidthColumnsCount++;
                    fixedColumnsWidth += Number( col?.props?.style?.minWidth?.substring( 0, col?.props?.style?.minWidth?.length - 2 ?? 0 ) ?? 150 );
                }
                else {
                    fixedColumnsWidth += Number( col?.props?.style?.width?.substring( 0, col?.props?.style?.width?.length - 2 ?? 0 ) ?? col?.props?.style?.minWidth?.substring( 0, col?.props?.style?.minWidth?.length - 2 ?? 0 ) ?? 0 );
                }
            }

            tableWidth = `${fixedColumnsWidth}px`;

            if ( autoWidthColumnsCount > 0 && scrollElementWidth > fixedColumnsWidth ) {
                tableWidth = '100%';
            }
        }

        /* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
        return <div
            key={`${uid}_datatable_wrapper`}
            id={`${uid}_datatable_wrapper`}
            style={{ position: 'relative' }}
            className="yn-flex-layout-parent"
            onClick={this.onClick}
        >
            <ContextMenu
                ref={element => this.contextMenuRef = element}

                model={this.getContextMenuModel( this.state.contextMenuCellInfo )}
                onHide={this.onContextMenuHide}
                style={{ width: 'auto' }}
            />
            <LoadingMaskPanel key={`${uid}_loadingMask`} forComponent={uid} className="yn-flex-layout-parent">
                <PrDataTable
                    ref={element => this.dataTable = element}

                    key={`${uid}_datatable`}
                    id={`${uid}_datatable`}

                    value={this.dataTableValue}

                    dataKey={dataKey}
                    emptyMessage={emptyMessage}

                    className={dataTableClassName}
                    tableClassName={editMode ? 'yn-edit' : ''}
                    rowClassName={this.onResolveRowClass}
                    style={{ width: '100% !important', zIndex: 1 }}
                    tableStyle={{ tableLayout: 'fixed', width: tableWidth }}

                    // column filtering
                    filterDisplay={filterDisplay}

                    // column reordering
                    reorderableColumns={reorderable}
                    onColReorder={reorderable ? this.onColReorder : undefined}

                    // column resizing
                    resizableColumns={resizable}
                    columnResizeMode="expand"
                    onColumnResizeEnd={resizable ? this.onColumnResizeEnd : undefined}

                    // scrolling
                    scrollable
                    scrollHeight="flex"

                    // lazy loading
                    lazy
                    //loading={loading}
                    first={( page - 1 ) * rows}
                    rows={rows}
                    totalRecords={totalRecords}

                    // pagination
                    paginator={usePaging}
                    paginatorTemplate={usePaging
                        ? {
                            layout             : 'CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
                            'CurrentPageReport': ( options ) => {
                                let message = 'YN.base.common.paginator.currentPageReport';

                                if ( global.config.common.limitMaxReturnedRows && global.config.common.limitMaxReturnedRows < ( totalRecords ?? 0 ) ) {
                                    message = 'YN.base.common.paginator.moreThanLimitMaxReturnedRowsCurrentPageReport';
                                }

                                return parse( `<span aria-live="polite" class="p-paginator-current">${__( message, {
                                    currentPage         : String( options.currentPage ),
                                    totalPages          : String( options.totalPages ),
                                    first               : String( options.first ),
                                    last                : String( options.last ),
                                    rows                : String( options.rows ),
                                    totalRecords        : String( options.totalRecords ),
                                    limitMaxReturnedRows: String( global.config.common.limitMaxReturnedRows )
                                } )}</span>` );
                            },
                            ...paginatorTemplate
                        }
                        : undefined
                    }
                    rowsPerPageOptions={[ 20, 50, 100, 200, 500 ]}
                    onPage={this.onPage}

                    // selection
                    selection={selection}
                    selectionMode={selectable || editMode ? 'single' : undefined}
                    cellSelection={editMode ? undefined : false}
                    onSelectionChange={this.onSelectionChange}

                    // sort
                    removableSort
                    sortMode="multiple"
                    onSort={this.props.onSort ?? this.onSort}
                    multiSortMeta={sorters.length ? this.getMultiSortMeta( sorters ) : undefined}

                    // row click
                    onRowClick={this.onRowClick}

                    // row expanding
                    expandedRows={expandedRows}
                    onRowToggle={this.onRowToggle}
                    rowExpansionTemplate={rowExpansionTemplate}

                    // row grouping
                    groupRowsBy={groupRowsBy}
                    rowGroupMode={rowGroupMode}
                    rowGroupHeaderTemplate={rowGroupHeaderTemplate}
                    rowGroupFooterTemplate={rowGroupFooterTemplate}
                    expandableRowGroups={expandableRowGroups}

                    // context menu
                    contextMenuSelection={this.state.contextMenuSelection}
                    onContextMenuSelectionChange={this.onContextMenuSelectionChange}
                    onContextMenu={this.onContextMenu}

                    footer={footer}

                    pt={{
                        wrapper: {
                            className: filterDisplay === 'row' ? 'yn-datatable-filtered' : undefined,
                            style    : {
                                '--table-width'        : '100%',
                                '--table-header-height': filterDisplay === 'row' ? '4.4rem' : '2.2rem'
                            }
                        },
                        ...pt
                    }}
                >
                    {this.renderedColumns}
                </PrDataTable>
            </LoadingMaskPanel>
        </div>;
    }
}

/**
 * REDUX stuff
 */
function mapStateToProps( state : StoreState, ownProps : ComponentProps ) : StateProps {
    const retVal : StateProps = {
        xhrRequestsForComponent: undefined,
        elusiveData            : undefined,
        user                   : undefined,
        messageCatalogTimestamp: 0,
        debug                  : false
    };

    // get the running xhr request belonging to this component (uid)
    if ( state.xhr?.[ ownProps.uid ] ) {
        retVal.xhrRequestsForComponent = state.xhr[ ownProps.uid ];
    }

    // get elusiveData
    // for the data (items and references) belonging to this component
    if ( state.elusiveData?.[ ownProps.dataContext ] ) {
        retVal.elusiveData = {
            ...retVal.elusiveData ?? {},
            ...state.elusiveData[ ownProps.dataContext ]
        };
    }
    // for all other information belonging to this component
    if ( state.elusiveData?.[ ownProps.uid ] ) {
        retVal.elusiveData = {
            ...retVal.elusiveData ?? {},
            ...state.elusiveData[ ownProps.uid ]
        };
        retVal.ownElusiveData = state.elusiveData[ ownProps.uid ];
    }

    // get some session user information
    if ( state.session?.user ) {
        retVal.user = state.session.user;
    }

    if ( state.messagecatalog?.timestamp ) {
        retVal.messageCatalogTimestamp = state.messagecatalog.timestamp;
    }

    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    if ( state.debugConfig?.dataTableDebug?.showAll || state.debugConfig?.dataTableDebug?.dedicated?.[ ownProps.uid ] ) {
        retVal.debug = true;
    }

    return retVal;
}

/**
 * REDUX stuff
 */
function mapDispatchToProps( dispatch : Dispatch ) {
    return bindActionCreators( Actions, dispatch );
}

export default connect<StateProps, ActionProps, ComponentProps, StoreState>( mapStateToProps, mapDispatchToProps, undefined, { forwardRef: true } )( DataTable );
